{
    "DATE": {
        "YESTERDAY": "Hier",
        "TODAY": "Aujourd'hui",
        "TOMORROW": "Demain"
    },
    "ENUM": {
        "CLIENT_TYPE": {
            "DEBT_MEDIATION": {
                "LABEL": "Médiation de dettes",
                "ICON": "debt-mediation"
            },
            "FINANCIAL_MANAGEMENT": {
                "LABEL": "Administration de biens",
                "ICON": "guardianship"
            },
            "SOCIAL_RENT": {
                "LABEL": "Loyer social",
                "ICON": "social-rent"
            },
            "BUDGET_GUIDANCE": {
                "LABEL": "Orientations budgétaires",
                "ICON": "budget-management"
            },
            "RENT": {
                "LABEL": "Loyer",
                "ICON": "rent"
            },
            "PCSW": {
                "LABEL": "PCSW",
                "ICON": "pcsw"
            }
        },
        "BANK_ACCOUNT_OWNER_TYPE": {
            "CLIENT": {
                "ICON": "clients"
            },
            "OFFICE": {
                "ICON": "office-account"
            }
        },
        "BANK_ACCOUNT_TYPE": {
            "BASE": {
                "LABEL": "Compte de base"
            },
            "RESERVE": {
                "LABEL": "Compte de réserve"
            },
            "SAVINGS": {
                "LABEL": "Compte d'épargne"
            },
            "ALLOWANCE": {
                "LABEL": "Compte d'argent de poche"
            },
            "SECURITY": {
                "LABEL": "Compte de garantie (locative)"
            },
            "VAPH": {
                "LABEL": "Compte VAPH"
            },
            "INVEST": {
                "LABEL": "Compte d'investissement"
            }
        },
        "LANGUAGE": {
            "NL": "Néerlandais",
            "FR": "Français",
            "EN": "Anglais"
        },
        "MOBILE_APP_USER_LOGIN_TYPE": {
            "PHONE": {
                "LABEL": "Numéro de GSM"
            },
            "EMAIL": {
                "LABEL": "E-mail"
            }
        }
    },
    "TOAST": {
        "INFO": {
            "UPDATE_AVAILABLE": {
                "TITLE": "Mise à jour disponible !",
                "MESSAGE": "Cliquez ici ou actualisez la page pour charger la nouvelle version."
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Génération de document en cours",
                "MESSAGE": "Vous serez informé(e) lorsque le document sera prêt."
            }
        },
        "ERROR": {
            "UNKNOWN": {
                "TITLE": "Erreur inconnue"
            },
            "BAD_REQUEST": {
                "TITLE": "Mauvaise demande"
            },
            "FORBIDDEN": {
                "TITLE": "Interdit"
            },
            "NOT_FOUND": {
                "TITLE": "Non trouvé"
            },
            "UPLOAD_DOCUMENTS": {
                "TITLE": "L'importation des documents a échoué"
            },
            "CREATE_ACTIVE_DEBT_DOSSIERS_REPORT": {
                "TITLE": "La génération du rapport a échoué"
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "La génération du document a échoué"
            }
        },
        "SUCCESS": {
            "ADD_CLIENT": {
                "TITLE": "Le client a été créé avec succès"
            },
            "INFO_SAVED": {
                "TITLE": "Les informations de base ont été mises à jour"
            },
            "CLIENT_ACCOUNTS_SAVED": {
                "TITLE": "Les comptes bancaires ont été mis à jour"
            },
            "ACCOUNT_CLIENT_SETTINGS_SAVED": {
                "TITLE": "Les paramètres du client ont été mis à jour"
            },
            "TRANSACTION": {
                "CATEGORY": {
                    "SAVED": {
                        "TITLE": "La catégorie a été mise à jour",
                        "ALL_CLIENTS": {
                            "TITLE": "La catégorie a été mise à jour",
                            "MESSAGE": "La catégorie a été définie pour tous les comptes du client lié. Le traitement des autres comptes a été lancé en arrière-plan."
                        }
                    }
                }
            },
            "CLIENT_ARCHIVED": {
                "TITLE": "Le client a été archivé"
            },
            "CLIENT_RESTORED": {
                "TITLE": "Le client a été rétabli"
            },
            "PDF_EXPORTED": {
                "TITLE": "L'exportation en PDF a été téléchargée."
            },
            "XLSX_EXPORTED": {
                "TITLE": "L'exportation en Excel a été téléchargée."
            },
            "BANK_ACCOUNT_ARCHIVED": {
                "TITLE": "Le compte a été archivé"
            },
            "BANK_ACCOUNT_RESTORED": {
                "TITLE": "Le compte a été rétabli"
            },
            "DOCUMENT_DOWNLOADED": {
                "TITLE": "Le document a été téléchargé"
            },
            "DOCUMENT_RESPONSE_ADDED": {
                "TITLE": "La demande de paiement a été traitée"
            },
            "TRANSACTION_TAGS_SAVED": {
                "TITLE": "Les étiquettes ont été mises à jour"
            },
            "DOSSIER_SAVED": {
                "TITLE": "Le dossier a été mis à jour"
            },
            "DIVIDEND_CREATED": {
                "TITLE": "Les paiements ont été créés"
            },
            "RB_DOCUMENT_CREATED": {
                "TITLE": "La génération du document est en cours. Le document sera ajouté à la liste des documents une fois terminée."
            },
            "UPLOAD_DOCUMENTS": {
                "TITLE": "Les documents ont été importés"
            },
            "PAYMENT_SAVED": {
                "TITLE": "Le paiement a été enregistré"
            },
            "DOCUMENT_RENAMED": {
                "TITLE": "Le document a été renommé"
            },
            "DOCUMENT_DELETED": {
                "TITLE": "Les documents ont été supprimés"
            },
            "DOCUMENT_UPDATED": {
                "TITLE": "Le document a été mis à jour"
            },
            "PAYMENT_DELETED": {
                "TITLE": "Le paiement  a été supprimé"
            },
            "CLIENT_APPLICATION_INVITATION": {
                "TITLE": "L'invitation a été envoyée"
            },
            "ACCOUNT_USER_SAVED": {
                "TITLE": "Les données personnelles ont été mises à jour"
            },
            "PASSWORD_SAVED": {
                "TITLE": "Mot de passe a été mis à jour"
            },
            "OFFICE_SAVED": {
                "TITLE": "Le bureau a été mis à jour"
            },
            "OFFICE_USER_ADDED": {
                "TITLE": "L'utilisateur a été ajouté",
                "MESSAGE": "Une invitation a été envoyée par e-mail."
            },
            "OFFICE_USER_UPDATED": {
                "TITLE": "L'utilisateur a été mis à jour"
            },
            "REDIRECTING_TO_FINANCIAL_INSTITUTION": {
                "TITLE": "Vous serez redirigé vers la banque"
            },
            "REDIRECTING_TO_ISABEL": {
                "TITLE": "Vous serez redirigé vers Isabel 6"
            },
            "CREDITORS_IMPORTED": {
                "TITLE": "Les créanciers ont été importés"
            },
            "CREATE_ACTIVE_DEBT_DOSSIERS_REPORT": {
                "TITLE": "Le rapport a été généré"
            },
            "DOCUMENT_ASSIGNED": {
                "TITLE": "Les documents ont été attribués"
            },
            "NOTIFICATIONS_PROCESSED": {
                "TITLE": "Les notifications ont été fermées"
            },
            "PAYMENTS_SUBMITTED": {
                "TITLE": "Les paiements ont été soumis à Isabel 6"
            },
            "PASSWORD_UPDATED": {
                "TITLE": "Vérifiez votre e-mail",
                "MESSAGE": "Vous recevrez un e-mail contenant des instructions pour définir un nouveau mot de passe."
            },
            "OFFICE_TRANSACTION_CATEGORY_ADDED": {
                "TITLE": "Catégorie ajoutée"
            },
            "OFFICE_TRANSACTION_CATEGORY_UPDATED": {
                "TITLE": "Catégorie modifiée"
            },
            "OFFICE_TRANSACTION_CATEGORY_DELETED": {
                "TITLE": "Catégorie supprimée"
            },
            "BUDGET_SAVED": {
                "TITLE": "Budget enregistré",
                "MESSAGE": "Le budget a été enregistré avec succès."
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Le document a été généré",
                "MESSAGE": "Le document est prêt et a été ajouté à la liste.",
                "LINK": "Consulter"
            }
        },
        "WARNING": {
            "PDF_NOT_EXPORTED": {
                "TITLE": "L'exportation en PDF est limitée à 3000 transactions. Veuillez ajuster les filtres."
            },
            "XLSX_NOT_EXPORTED": {
                "TITLE": "L'exportation en Excel est limitée à 3000 transactions. Veuillez ajuster les filtres."
            },
            "MAX_UPLOAD_FILE_SIZE": {
                "TITLE": "La taille maximale du fichier est dépassée",
                "MESSAGE": "Seuls les fichiers de moins de 20 MB peuvent être ajoutés."
            },
            "MAX_UPLOAD_REQUEST_SIZE": {
                "TITLE": "La taille maximale du importation est dépassée",
                "MESSAGE": "La taille totale d'un importation doit être inférieure à 200 MB."
            },
            "FILE_TYPE": {
                "TITLE": "Le type de fichier n'est pas supporté"
            }
        }
    },
    "LOGIN": {
        "HEADER": "Connexion",
        "FORM": {
            "FIELD": {
                "USERNAME": {
                    "PLACEHOLDER": "Courriel",
                    "ERROR": {
                        "REQUIRED": "Exigée",
                        "EMAIL": "L'adresse e-mail n'est pas valide"
                    }
                },
                "PASSWORD": {
                    "PLACEHOLDER": "Mot de passe",
                    "ERROR": {
                        "REQUIRED": "Exigée",
                        "INVALID": "L'adresse électronique et/ou le mot de passe sont incorrects"
                    }
                }
            },
            "BUTTON": {
                "SUBMIT": {
                    "LABEL": "Connexion"
                }
            }
        },
        "CC_ACCESS": {
            "MESSAGE": "Vous allez vous connecter au bureau « <strong>{{ office }}</strong> »"
        },
        "SUCCESS": {
            "TITLE": "Connecté",
            "LINK": "Cliquez ici si vous n’êtes pas redirigé automatiquement"
        },
        "ERROR": {
            "TITLE": "Erreur de connexion",
            "BUTTON": "Se reconnecter"
        }
    },
    "APP": {
        "SIDENAV": {
            "MENU": {
                "ITEM": {
                    "DASHBOARD": {
                        "LABEL": "Tableau de bord",
                        "TOOLTIP": "Tableau de bord"
                    },
                    "CLIENTS": {
                        "LABEL": "Clients",
                        "TOOLTIP": "Clients"
                    },
                    "MESSAGES": {
                        "LABEL": "Messages",
                        "TOOLTIP": "Messages"
                    },
                    "CONTACTS": {
                        "LABEL": "Contacts",
                        "TOOLTIP": "Contacts"
                    },
                    "BANK_ACCOUNTS": {
                        "LABEL": "Comptes",
                        "TOOLTIP": "Comptes bancaires"
                    },
                    "PAYMENTS": {
                        "LABEL": "Paiements",
                        "TOOLTIP": "Paiements"
                    },
                    "NOTIFICATIONS": {
                        "LABEL": "Notifications",
                        "TOOLTIP": "Notifications"
                    },
                    "OTHER": {
                        "LABEL": "Autres",
                        "TOOLTIP": "Autres",
                        "MENU": {
                            "ITEM": {
                                "ACTIONS": {
                                    "LABEL": "Actions",
                                    "TOOLTIP": "Actions"
                                },
                                "ARCHIVE": {
                                    "MENU": {
                                        "ITEM": {
                                            "CLIENTS": {
                                                "LABEL": "Archives des clients",
                                                "TOOLTIP": "Archives des clients"
                                            },
                                            "BANK_ACCOUNTS": {
                                                "LABEL": "Archives des comptes bancaires",
                                                "TOOLTIP": "Archives des comptes bancaires"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "OFFICE": {
                        "LABEL": "Mon bureau",
                        "TOOLTIP": "Mon bureau"
                    },
                    "PROFILE": {
                        "LABEL": "Mon profil",
                        "TOOLTIP": "Mon profil"
                    },
                    "SETTINGS": {
                        "LABEL": "Paramètres",
                        "TOOLTIP": "Paramètres"
                    },
                    "DOCUMENTS": {
                        "LABEL": "Documents",
                        "TOOLTIP": "Documents"
                    }
                },
                "ACTION": {
                    "LOGOUT": {
                        "LABEL": "Déconnexion",
                        "TOOLTIP": "Déconnexion"
                    },
                    "ISABEL": {
                        "TOOLTIP": "Isabel 6 Customer Zone"
                    },
                    "COLLAPSE": {
                        "LABEL": "Réduire",
                        "TOOLTIP": "Déplier"
                    },
                    "HELPDESK": {
                        "LABEL": "Helpdesk",
                        "TOOLTIP": "Helpdesk",
                        "URL": "https://roov.app/fr/helpdesk/1"
                    }
                }
            }
        },
        "ACTIONS": {
            "HEADER": {
                "LABEL": "Actions"
            }
        },
        "ARCHIVE": {
            "BANK_ACCOUNTS": {
                "HEADER": {
                    "LABEL": "Archives des comptes bancaires"
                }
            },
            "CLIENTS": {
                "HEADER": {
                    "LABEL": "Archives des clients"
                }
            }
        },
        "BANK_ACCOUNTS": {
            "HEADER": {
                "LABEL": "Comptes bancaires"
            },
            "FILTER": {
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Recherche"
                },
                "LINKED": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Tous les comptes"
                        },
                        "TRUE": {
                            "LABEL": "Liés"
                        },
                        "FALSE": {
                            "LABEL": "Non-liés"
                        }
                    }
                },
                "WITH_WARNING": {
                    "LABEL": "Avec avertissement"
                },
                "FINANCIAL_INSTITUTION": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Tous les banques"
                        }
                    }
                }
            },
            "BUTTON": {
                "ADD": {
                    "LABEL": "Ajouter un compte"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "FINANCIAL_INSTITUTION": {
                        "HEADER": {
                            "LABEL": "Banque"
                        }
                    },
                    "LABEL": {
                        "HEADER": {
                            "LABEL": "Compte"
                        }
                    },
                    "IBAN": {
                        "HEADER": {
                            "LABEL": "Numéro de compte"
                        }
                    },
                    "BALANCE": {
                        "HEADER": {
                            "LABEL": "Solde"
                        }
                    },
                    "SYNCHRONIZED_AT": {
                        "HEADER": {
                            "LABEL": "Synchronisé"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Lié à"
                        }
                    },
                    "LATEST_TRANSACTION": {
                        "HEADER": {
                            "LABEL": "Dernière transaction"
                        }
                    }
                },
                "EMPTY": "Aucun compte trouvé"
            },
            "WARNINGS": {
                "ARCHIVED": "Archivé",
                "AUTH_INVALID": "Autorisation non valide",
                "EXPIRING": "L'autorisation expire",
                "MOVED_TO_ISABEL": "La banque a migré vers Isabel Connect",
                "TECHNICAL_FAILURE": "Problème technique temporaire",
                "NOT_FOUND_ISABEL": "Non disponible via Isabel Connect",
                "BLOCKED": ""
            },
            "API_PRODUCT": {
                "ISABEL": {
                    "TOOLTIP": "Lien via Isabel Connect"
                },
                "IMPORT": {
                    "TOOLTIP": "Importé, pas de lien actif"
                }
            }
        },
        "CLIENTS": {
            "HEADER": {
                "LABEL": "Clients"
            },
            "FILTER": {
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Recherche"
                },
                "CLIENT_TYPE": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Tous les types de clients"
                        }
                    }
                },
                "OPEN_NOTIFICATIONS_ONLY": {
                    "LABEL": "Notifications ouvertes uniquement"
                },
                "USER": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Tous les clients"
                        },
                        "MY": {
                            "LABEL": "Mes clients"
                        },
                        "OTHER": {
                            "LABEL": "Les clients de"
                        }
                    }
                }
            },
            "BUTTON": {
                "ADD": {
                    "LABEL": "Ajouter un client"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "NAME": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    },
                    "LAST_NOTIFICATION": {
                        "HEADER": {
                            "LABEL": "Dernière notification"
                        },
                        "SUBTITLE": "{{count}} ouvert"
                    },
                    "BANK_ACCOUNTS": {
                        "HEADER": {
                            "LABEL": "Comptes bancaires"
                        },
                        "WARNING": {
                            "TOOLTIP": "Ce compte bancaire est sur le point d'expirer"
                        }
                    },
                    "BALANCE": {
                        "HEADER": {
                            "LABEL": "Solde"
                        }
                    }
                },
                "EMPTY": "Aucun client trouvé"
            },
            "CLIENT": {
                "BREADCRUMB": {
                    "LABEL": "Clients"
                },
                "BANK_ACCOUNTS": {
                    "HEADER": {
                        "LABEL": "Comptes bancaires"
                    },
                    "EMPTY": "Pas de comptes bancaires disponibles"
                },
                "TAB": {
                    "NOTIFICATIONS": {
                        "LABEL": "Notifications",
                        "ONLY_UNPROCESSED": {
                            "LABEL": "Notifications ouvertes uniquement"
                        },
                        "TABLE": {
                            "COLUMN": {
                                "ACCOUNT": {
                                    "HEADER": {
                                        "LABEL": "Compte bancaire"
                                    }
                                },
                                "NOTIFICATION": {
                                    "HEADER": {
                                        "LABEL": "Notification"
                                    },
                                    "ACCEPTED": "Accepter",
                                    "DECLINED": "Refuser"
                                },
                                "CLOSED": {
                                    "HEADER": {
                                        "LABEL": "Fermée"
                                    }
                                }
                            },
                            "EMPTY": "Aucune notification trouvée"
                        },
                        "PROCESS_NOTIFICATIONS": {
                            "LABEL": "Tout fermer"
                        }
                    },
                    "INFO": {
                        "LABEL": "Infos de base"
                    },
                    "DOSSIER": {
                        "LABEL": "Dossier"
                    },
                    "DOCUMENTS": {
                        "LABEL": "Documents"
                    },
                    "APPLICATION": {
                        "LABEL": "Application client"
                    },
                    "DOSSIER_DEBT_MEDIATION": {
                        "LABEL": "RCD"
                    },
                    "DOSSIER_FINANCIAL_MANAGEMENT": {
                        "LABEL": "Administration"
                    },
                    "BUDGET": {
                        "LABEL": "Budget"
                    }
                },
                "SET_ARCHIVED_STATUS": {
                    "DIALOG": {
                        "TITLE": "Archiver",
                        "STATUS": {
                            "TITLE": "Statut",
                            "ACTIVE": "Actif",
                            "ARCHIVED": "A été archivé le {{ date }}"
                        },
                        "ACTION": {
                            "TITLE": "Action",
                            "ACTIVE": "Archiver",
                            "ARCHIVED": "Rétablir"
                        },
                        "INFO": {
                            "ARCHIVED": "Le rétablissement d'un client implique :\n<ul>\n<li>Le client est à nouveau affiché dans la liste des clients actifs.</li>\n<li>Les informations de base et les données du dossier peuvent être réajustées.</li>\n<li>Les documents peuvent être téléchargés ou générés à nouveau.</li>\n<li>Un nouveau lien vers l'application client peut être établi (un lien précédent ne sera pas restauré).</li>\n<li>Il est à nouveau possible de lier un compte bancaire à ce client ou de déconnecter les comptes bancaires de ce client.</li>\n<li>Les comptes bancaires liés restent archivés, mais peuvent être restaurés séparément.</li>\n<li>De nouvelles notifications pour ce client peuvent apparaître à nouveau.</li>\n</ul>",
                            "ACTIVE": "Archiver un client implique :\n<ul>\n<li>Le client n'apparaît plus dans la liste des clients actifs.</li>\n<li>Les informations de base et les données du dossier ne peuvent plus être modifiées.</li>\n<li>Plus aucun document ne peut être téléchargé ou généré.</li>\n<li>Tout lien vers l'application client sera rompu et les informations relatives au compte ne seront plus partagées.</li>\n<li>Il n'est plus possible de lier un compte bancaire à ce client ou de déconnecter les comptes bancaires de ce client.</li>\n<li>Tous les comptes bancaires liés sont archivés et ne sont donc plus synchronisés.</li>\n<li>Toutes les notifications ouvertes sont fermées et aucune nouvelle notification n'est créée.</li>\n</ul>"
                        }
                    }
                }
            },
            "ADD_CLIENT_DIALOG": {
                "TITLE": "Nouveau client",
                "CONTENT": {
                    "INFO": {
                        "HEADER": "Infos de base"
                    },
                    "TYPE": {
                        "HEADER": "Type",
                        "FORM": {
                            "FIELD": {
                                "TYPE": {
                                    "ERROR": {
                                        "REQUIRED": "Exigée"
                                    }
                                }
                            }
                        }
                    }
                },
                "BUTTON": {
                    "CONFIRM": {
                        "LABEL": "Confirmer"
                    },
                    "CANCEL": {
                        "LABEL": "Annuler"
                    }
                }
            },
            "CLIENT_INFO": {
                "EDIT": {
                    "DIALOG": {
                        "FIELD": {
                            "EMAIL": {
                                "ERROR": {
                                    "REQUIRED": "Exigée",
                                    "EMAIL": "L'adresse e-mail n'est pas valide"
                                }
                            },
                            "FIRSTNAME": {
                                "ERROR": {
                                    "REQUIRED": "Exigée"
                                }
                            },
                            "SSN": {
                                "ERROR": {
                                    "INPUT_MASK": "Numéro de registre national non valide"
                                }
                            },
                            "DATE_OF_BIRTH": {
                                "ERROR": {
                                    "MAT_DATEPICKER_PARSE": "Date non valide",
                                    "MAT_DATEPICKER_MAX": "Les dates ultérieures ne sont pas autorisées",
                                    "INPUT_MASK": "Date non valide"
                                }
                            }
                        },
                        "TITLE": "Infos de Base",
                        "ERROR": {
                            "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                            "EMAIL": "L'adresse e-mail n'est pas valide",
                            "INPUT_MASK": "Numéro de registre national non valide",
                            "MAT_DATEPICKER_PARSE": "Date non valide",
                            "MAT_DATEPICKER_MAX": "Les dates ultérieures ne sont pas autorisées"
                        }
                    },
                    "LABEL": "Modifier"
                },
                "PERSONAL_INFO": {
                    "FIRSTNAME": "Prénom",
                    "LASTNAME": "Nom",
                    "STREET": "Rue",
                    "HEADER": "Données personnelles",
                    "NUMBER": "No / boîte",
                    "SSN": "Nr de registre national",
                    "POSTALCODE": "Code postal",
                    "BIRTHDATE": "Date de naissance",
                    "CITY": "Municipalité",
                    "PHONE": "Téléphone",
                    "EMAIL": "E-mail",
                    "LANGUAGE": "Langue"
                },
                "FAMILY_INFO": {
                    "HEADER": "Info partenaire et enfants",
                    "FIRSTNAME": "Prénom",
                    "LASTNAME": "Nom",
                    "PHONE": "Téléphone",
                    "EMAIL": "E-mail",
                    "CHILDREN": "Enfants"
                },
                "REMARKS": {
                    "HEADER": "Remarques",
                    "PLACEHOLDER": "Écrivez ici"
                }
            },
            "EDIT_ACCOUNTS": {
                "DIALOG": {
                    "TITLE": "Comptes bancaires",
                    "ACCOUNTS_MANAGED_BY": "Comptes gérés par {{name}}",
                    "OFFICE_ACCOUNT_INFO": "\nEntrez le numéro de compte ou sélectionnez un compte lié",
                    "CLIENT_ACCOUNT_INFO": "Entrez le numéro de compte",
                    "ADD_ACCOUNT": "Ajouter un compte",
                    "LINKED": "Relié par l'application client",
                    "NOT_LINKED": "Non lié",
                    "TYPE": {
                        "LABEL": "Type"
                    },
                    "LABEL": {
                        "LABEL": "Étiquette"
                    },
                    "IBAN": {
                        "LABEL": "IBAN",
                        "ERROR": {
                            "REQUIRED": "Exigée",
                            "INPUT_MASK": "IBAN non valide",
                            "IBAN": "IBAN non valide",
                            "LINKED": "Déjà lié à {{param}}",
                            "DUPLICATE": "Cet IBAN a déjà été utilisé"
                        }
                    },
                    "ERROR": {
                        "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                        "IBAN": "IBAN non valide",
                        "LINKED": "L'IBAN est déjà lié au autre client",
                        "DUPLICATE": "Cet IBAN a déjà été utilisé",
                        "ADD_ENABLED": "Ajoutez le compte avant de pouvoir confirmer"
                    },
                    "ACCOUNT": {
                        "LABEL": "Compte"
                    }
                }
            },
            "DOSSIER_INFO": {
                "GENERAL": {
                    "HEADER": "Général",
                    "START_DATE": {
                        "LABEL": "Date de début"
                    },
                    "END_DATE": {
                        "LABEL": "Date de fin"
                    },
                    "DOSSIER_NUMBER": {
                        "LABEL": "Numéro de dossier"
                    },
                    "BALANCE_THRESHOLD": {
                        "LABEL": "Seuil pour les notifications “Solde au-dessus de …“"
                    },
                    "HOMOLOGATION_DATE": {
                        "LABEL": "Date d'homologation"
                    },
                    "ADMISSIBILITY_DATE": {
                        "LABEL": "Date de l'ordonnance d'admissibilité"
                    },
                    "LABOUR_COURT": {
                        "LABEL": "Tribunal du travail",
                        "DEFAULT": "Tribunal de travail par défaut"
                    },
                    "DOCKET_NUMBER": {
                        "LABEL": "Numéro de rôle"
                    },
                    "JUSTICE_PEACE": {
                        "LABEL": "Justice de paix",
                        "DEFAULT": "Justice de paix par défaut"
                    },
                    "START_DATE_PLAN": {
                        "LABEL": "Date de début du plan"
                    },
                    "END_DATE_PLAN": {
                        "LABEL": "Date de fin du plan"
                    },
                    "DEBT_MEDIATOR": {
                        "LABEL": "Médiateur de dettes",
                        "DEFAULT": "Médiateur de dettes par défaut"
                    },
                    "ADMINISTRATOR": {
                        "LABEL": "Administrateur",
                        "DEFAULT": "Administrateur par defaut"
                    },
                    "ASSIGNEE": {
                        "LABEL": "Gestionnaire du dossier",
                        "NONE": {
                            "LABEL": "Pas de gestionnaire du dossier"
                        }
                    },
                    "START_DATE_REPORT": {
                        "LABEL": "Date de début du rapport"
                    }
                },
                "EDIT": {
                    "LABEL": "Modifier",
                    "DIALOG": {
                        "FIELD": {
                            "END_DATE": {
                                "ERROR": {
                                    "NOT_BEFORE_START_DATE": "Avant la date de début"
                                }
                            }
                        }
                    }
                },
                "FINANCIAL": {
                    "HEADER": "Situation financière",
                    "TOTAL_DEBT": {
                        "LABEL": "Total de la dette"
                    },
                    "MAIN_SUM": {
                        "LABEL": "Montant principal"
                    },
                    "INTEREST": {
                        "LABEL": "Intérêt"
                    },
                    "COSTS": {
                        "LABEL": "Coûts"
                    },
                    "COURT_COSTS": {
                        "LABEL": "Frais de justice"
                    },
                    "INCREASES": {
                        "LABEL": "Majorations"
                    },
                    "MONTHLY_INCOME": {
                        "LABEL": "Revenus / m"
                    },
                    "MONTHLY_EXPENSES": {
                        "LABEL": "Dépenses / m"
                    },
                    "DIFFERENCE": "Différence"
                },
                "SETTLEMENT": {
                    "HEADER": "Plan de règlement",
                    "TYPE": {
                        "LABEL": "Type",
                        "MONTHLY": "Réserve mensuelle",
                        "PERCENTAGE": "Pourcentage",
                        "BALANCE": "Règlement du solde",
                        "MORATORIUM": "Moratorium",
                        "NONE": "Aucun"
                    },
                    "MONTHLY": {
                        "LABEL": "Réserve mensuelle"
                    },
                    "PERCENTAGE": {
                        "LABEL": "Pourcentage"
                    },
                    "PERIODICITY": {
                        "LABEL": "Périodicité du paiements (mois)"
                    },
                    "START_DATE": {
                        "LABEL": "Date de début du paiement"
                    },
                    "END_DATE": {
                        "LABEL": "Date de fin du paiement"
                    },
                    "RETAINED_AMOUNT": {
                        "LABEL": "Retenu"
                    },
                    "SUMMARY": {
                        "TITLE": "Résumé",
                        "COPY": {
                            "LABEL": "Copier"
                        },
                        "REPAYMENT": {
                            "MONTHLY_OR_PERCENTAGE": "Remboursement de {{totalSumToPay}} ({{percentage}} de {{referenceAmount}}) sur une période de {{period}}.",
                            "BALANCE": "Remboursement d’au maximum {{referenceAmount}} dans la mesure où des fonds sont disponibles sur une période de {{period}}.",
                            "MORATORIUM": "Toutes les mesures d’exécution sont suspendues."
                        },
                        "DIVIDEND": {
                            "MONTHLY_OR_PERCENTAGE": "Un dividende de {{periodicAmountToPay}} sera versé {{periodicity}} aux créanciers au prorata.",
                            "BALANCE": "Un dividende sera versé {{periodicity}} aux créanciers au prorata si des fonds sont disponibles."
                        },
                        "FIRST_DIVIDEND": {
                            "MONTHLY_OR_PERCENTAGE": "Les premiers dividendes seront payés le {{paymentStartDate}}.",
                            "BALANCE": "Les premiers dividendes seront potentiellement payés le {{paymentStartDate}}."
                        },
                        "REFERENCE_AMOUNT": {
                            "TOTAL_DEBT": "la dette totale",
                            "MAIN_SUM": "les sommes principales",
                            "RETAINED_AMOUNT": "les montants retenus"
                        },
                        "PERIOD": {
                            "YEARS": "{{years}} an(s)",
                            "YEARS_MONTHS": "{{years}} an(s) et {{months}} mois"
                        },
                        "PERIODICITY": {
                            "YEARLY": "annuellement",
                            "MONTHLY": "tous les {{months}} mois"
                        },
                        "NONE": "Le plan de règlement n'a pas encore été rédigé.",
                        "INCOMPLETE": "Le plan de règlement est incomplet."
                    }
                },
                "CREDITORS": {
                    "HEADER": "Créanciers",
                    "COMPANY_NUMBER": {
                        "LABEL": "N° d'entreprise"
                    },
                    "ADDRESS": {
                        "LABEL": "Adresse"
                    },
                    "PAYMENT_THIRD": {
                        "LABEL": "Art. 334 ou paiement par des tiers"
                    },
                    "PAYMENTS": {
                        "TITLE": "Modalités de paiement",
                        "BUTTON": {
                            "LABEL": "Payer"
                        },
                        "IBAN": {
                            "LABEL": "IBAN"
                        },
                        "REMITTANCE_INFO": {
                            "LABEL": "Communication"
                        },
                        "PERIODIC_AMOUNT": {
                            "LABEL": "Montant périodique à payer",
                            "TOOLTIP": "Calculé sur la base des modalités du régime d'apurement et des montants retenus par les créanciers."
                        },
                        "PLANNED_REPAYMENT": {
                            "LABEL": "Remboursement prévu"
                        }
                    },
                    "NAME": {
                        "LABEL": "Nom"
                    },
                    "ADD": {
                        "PLACEHOLDER": "Sélectionnez un créancier",
                        "NEW_CREDITOR": "Nouveau créancier"
                    },
                    "SPLIT_COSTS": {
                        "LABEL": "Scinder les frais"
                    },
                    "OVERRIDE_RETAINED_AMOUNTS": {
                        "LABEL": "Remplacer les montants retenus"
                    },
                    "TO_RETAIN": {
                        "LABEL": "à retenir"
                    },
                    "DATA": {
                        "TITLE": "Données"
                    },
                    "DESCRIPTION": {
                        "LABEL": "Identification"
                    },
                    "REMARKS": {
                        "LABEL": "Remarques"
                    }
                },
                "CREDITOR_PAYMENTS": {
                    "HEADER": "Tableau des remboursements",
                    "COLUMNS": {
                        "POSITION": "No.",
                        "NAME": "Créancier",
                        "RETAINED_AMOUNT": "Retenu",
                        "PAYMENT_THIRD_PARTIES": "Art. 334 ou<br/>remb. par un tiers",
                        "REMAINING_DEBT": "Solde",
                        "DISTRIBUTION": "Répartition<br/>au prorata"
                    },
                    "TOTAL": "Totaux"
                },
                "CREATE_DIVIDEND": {
                    "LABEL": "Payer un dividende",
                    "DIALOG": {
                        "TITLE": "Payer un dividende",
                        "ERROR": {
                            "IBAN": "IBAN non valide",
                            "REMITTANCE_INFORMATION": "Communication non valide",
                            "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                            "MAT_DATEPICKER_MIN": "La date d'exécution ne doit pas se situer dans le passé",
                            "MAT_DATEPICKER_PARSE": "Date non valide",
                            "MIN": "Le montant doit être supérieur à 0"
                        }
                    },
                    "BANK_ACCOUNT": {
                        "LABEL": "Compte bancaire",
                        "PLACEHOLDER": "Aucun compte disponible"
                    },
                    "EXECUTION_DATE": {
                        "LABEL": "Date"
                    },
                    "TOTAL_AMOUNT": {
                        "LABEL": "Montant total"
                    },
                    "CREDITORS": {
                        "TITLE": "Créanciers",
                        "EMPTY": "Aucun créancier",
                        "POSITION": {
                            "LABEL": "N°"
                        },
                        "COUNTERPART_NAME": {
                            "LABEL": "Créancier"
                        },
                        "COUNTERPART_REFERENCE": {
                            "LABEL": "Numéro de compte"
                        },
                        "REMITTANCE_INFORMATION": {
                            "LABEL": "Communication"
                        },
                        "AMOUNT": {
                            "LABEL": "Montant"
                        }
                    }
                },
                "IMPORT_CREDITORS": {
                    "LABEL": "Importer de JustRestart",
                    "DIALOG": {
                        "TITLE": "Dossier: importer les créanciers (JustRestart)",
                        "COLUMNS": {
                            "POSITION": {
                                "LABEL": "No."
                            },
                            "NAME": {
                                "LABEL": "Créancier"
                            },
                            "CAPITAL": {
                                "LABEL": "Capital"
                            },
                            "INTEREST": {
                                "LABEL": "Intérêts"
                            },
                            "NEGLIGENCE": {
                                "LABEL": "Intérêts de négligence"
                            },
                            "PENALTY": {
                                "LABEL": "Clause pénale"
                            },
                            "COSTS": {
                                "LABEL": "Coûts"
                            },
                            "TOTAL_DEBT": {
                                "LABEL": "Total de la dette"
                            },
                            "MAIN_SUM": {
                                "LABEL": "Montant principal"
                            },
                            "INCREASES": {
                                "LABEL": "Majorations"
                            },
                            "COURT_COSTS": {
                                "LABEL": "Frais de justice",
                                "LABEL_2": "Frais de justice"
                            },
                            "FIELD": {
                                "LABEL": "champ correspondant"
                            },
                            "TOTAL": {
                                "LABEL": "Total"
                            },
                            "TO_RETAIN": {
                                "LABEL": "à retenir"
                            },
                            "RETAINED_AMOUNT": {
                                "LABEL": "Retenu"
                            }
                        },
                        "IMPORT_DATA": {
                            "TITLE": "Données à importer",
                            "FILLED_BY": {
                                "LABEL": "complétées par",
                                "CREDITORS": "Les créanciers ({{columns}})",
                                "DEBT_MEDIATOR": "Le médiateur de dettes ({{columns}})"
                            }
                        },
                        "CHECK": {
                            "TITLE": "Contrôle"
                        },
                        "ERROR": {
                            "NON_FINAL": " ",
                            "MIN": "Seuls les montants positifs sont autorisés"
                        },
                        "VALIDATION": {
                            "TITLE": "Validation"
                        }
                    }
                },
                "MANUAL_CREDITORS": {
                    "LABEL": "Saisir manuellement"
                }
            },
            "CLIENT_NOTIFICATIONS": {
                "RESPOND_TO_DOCUMENT": {
                    "TITLE": "Demande de paiement",
                    "NOTIFICATION": "Demande de paiement",
                    "RESPONSE": "Répondre",
                    "MESSAGE": {
                        "TITLE": "Message au client (facultatif)",
                        "PLACEHOLDER": "Écrivez ici"
                    }
                }
            },
            "CLIENT_DOSSIER": {
                "EDIT": {
                    "DIALOG": {
                        "TITLE": "Dossier: {{ type }}",
                        "ERROR": {
                            "END_BEFORE_START": "La date de fin est antérieure à la date de début",
                            "SUM": "La dette totale n'est pas égale à la somme des dettes partielles",
                            "MIN": "La valeur est inférieure au minimum",
                            "MAX": "La valeur est supérieure au maximum",
                            "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                            "IBAN": "IBAN non valide",
                            "TOTAL_DEBT": "La dette totale du dossier n'est pas égale à la somme des dettes totales par créancier.",
                            "MAIN_SUM": "Le montant principal du dossier n'est pas égale à la somme des montants principaux par créancier.",
                            "INTEREST": "L'intérêt du dossier n'est pas égal à la somme des intérêts par créancier.",
                            "COSTS": "Les coûts du dossier ne sont pas égaux à la somme des coûts par créancier.",
                            "COURT_COSTS": "Les frais de justice du dossier ne sont pas égaux à la somme des frais de justice par créancier.",
                            "INCREASES": "Les majorations du dossier ne sont pas égales à la somme des majorations par créancier.",
                            "RETAINED_AMOUNT": "Le montant retenu du dossier n'est pas égale à la somme des montants retenus par créancier.",
                            "CREDITORS_UNIQUE": "Tous les créanciers ne sont pas uniques (même combinaison de nom, IBAN et communication).",
                            "REMITTANCE_INFORMATION": "Communication non valide",
                            "MAT_DATEPICKER_PARSE": "Date non valide"
                        }
                    }
                }
            },
            "EDIT_DOSSIER": {
                "DIALOG": {
                    "ADD_CREDITOR": "Ajouter un créancier"
                }
            },
            "CLIENT_DOCUMENTS": {
                "CREATE_RB_DOCUMENT": {
                    "DIALOG": {
                        "TITLE": "Générer un nouveau document",
                        "ERROR": {
                            "ACCOUNTS": "Aucun compte sélectionné",
                            "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis ou sélectionnés",
                            "MAT_DATEPICKER_MAX": "La période n'est pas comprise dans la plage autorisée",
                            "MAT_DATEPICKER_MIN": "La période n'est pas comprise dans la plage autorisée",
                            "END_BEFORE_START": "La date de fin est antérieure à la date de début"
                        }
                    },
                    "TYPE": {
                        "TITLE": "Type de document",
                        "DISABLED": "Certains types de documents ne peuvent pas être générés. Le client n'est pas lié aux comptes bancaires nécessaires.",
                        "UNAVAILABLE": "Il n'est pas possible de générer un document. Le client n'est pas lié aux comptes bancaires nécessaires."
                    },
                    "ACCOUNTS": {
                        "TITLE": "Comptes bancaires",
                        "NONE": "Aucune sélection de comptes ne doit être effectuée pour ce type de document.",
                        "OFFICE": "le bureau",
                        "CLIENT": "le client",
                        "MANAGED_BY": "Gérés par",
                        "BULK": "Des documents distincts sont générés pour chaque compte sélectionné.",
                        "MULTIPLE": "1 document est généré contenant tous les comptes sélectionnés."
                    },
                    "PERIOD": {
                        "TITLE": "Période",
                        "CUSTOM": "Libre",
                        "MONTHLY": "Mois",
                        "QUARTERLY": "Trimestre",
                        "YEARLY": "Année",
                        "NONE": "Aucune période ne doit être définie pour ce type de document.",
                        "FROM": "De",
                        "UNTIL": "Jusqu'à",
                        "COMPARE": "Comparaison avec la période précédente :"
                    },
                    "UNAVAILABLE": "Non disponible",
                    "HISTORY": {
                        "INCOMPLETE": "L'historique d'un ou plusieurs comptes est incomplet pour la période sélectionnée"
                    }
                }
            },
            "BUDGET": {
                "CALCULATION_PERIOD": {
                    "LABEL": "Période de référence pour les montants réels",
                    "YEAR_1": "1 an",
                    "MONTH_1": "1 mois",
                    "MONTH_3": "3 mois",
                    "MONTH_6": "6 mois"
                },
                "EDIT": {
                    "LABEL": "Modifier",
                    "DIALOG": {
                        "TITLE": "Budget"
                    },
                    "TABS": {
                        "INCOME": "Revenus",
                        "EXPENSES": "Dépenses",
                        "REMARKS": "Remarques"
                    },
                    "AUTOMATIC_ALLOWANCE": "Calculer automatiquement l'argent de poche",
                    "ACTUAL_PERIOD": "Période de référence pour les montants réels",
                    "RECEIVED_BY_CLIENT": "Reçu par le client",
                    "PAID_BY_CLIENT": "Payé par le client",
                    "DETAILED": "Budget détaillé",
                    "PERIOD": "Période",
                    "USE_ACTUAL": "Reprendre le montant réel",
                    "REMARK": {
                        "PLACEHOLDER": "Remarque"
                    },
                    "REMARKS": {
                        "PLACEHOLDER": "Remarques"
                    }
                },
                "REMARKS": {
                    "HEADER": "Remarques",
                    "COPY": "Copier"
                },
                "MANAGED_BY_CLIENT": {
                    "HEADER": "Plan budgétaire du client"
                },
                "TABLE": {
                    "CATEGORY": "Catégorie",
                    "PLAN": "Planifié",
                    "ACTUAL": "Réel",
                    "INCOME": "Revenus",
                    "EXPENSES": "Dépenses",
                    "PROVISION": "Provision pour frais imprévus et extras",
                    "TOTAL": "Total"
                },
                "PERIODICITY": {
                    "MONTHLY": {
                        "SHORT": "m"
                    },
                    "YEARLY": {
                        "SHORT": "an"
                    }
                },
                "MANAGED_BY_OFFICE": {
                    "DEBT_MEDIATION": {
                        "HEADER": "Plan budgétaire du médiateur de dettes"
                    },
                    "FINANCIAL_MANAGEMENT": {
                        "HEADER": "Plan budgétaire de l’administrateur"
                    },
                    "BUDGET_GUIDANCE": {
                        "HEADER": "Plan budgétaire du gestionnaire de budget"
                    },
                    "RENT": {
                        "HEADER": "Plan budgétaire du bailleur"
                    },
                    "SOCIAL_RENT": {
                        "HEADER": "Plan budgétaire du bailleur"
                    },
                    "PCSW": {
                        "HEADER": "Plan budgétaire du CPAS"
                    }
                },
                "UNPLANNED": {
                    "HEADER": "Hors plan budgétaire"
                },
                "UNCATEGORIZED": {
                    "LABEL": "Sans catégorie"
                },
                "CLIENT_ONLY": {
                    "EDIT_HEADER": "Total du plan budgétaire",
                    "VIEW_HEADER": "Plan budgétaire"
                }
            }
        },
        "CONTACTS": {
            "HEADER": {
                "LABEL": "Contacts"
            }
        },
        "DASHBOARD": {
            "HEADER": {
                "LABEL": "Tableau de bord"
            }
        },
        "MESSAGES": {
            "HEADER": {
                "LABEL": "Messages"
            }
        },
        "NOTIFICATIONS": {
            "HEADER": {
                "LABEL": "Notifications"
            },
            "FILTER": {
                "TYPE": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Tous les notifications"
                        },
                        "NOT_ENOUGH_FUNDS": {
                            "LABEL": "Balance est trop faible"
                        },
                        "BALANCE_EXCEEDED_THRESHOLD": {
                            "LABEL": "Solde supérieur á"
                        },
                        "INCOME_DETECTED": {
                            "LABEL": "Nouveau revenu détecté"
                        },
                        "INSUFFICIENT_BALANCE_EXPECTED": {
                            "LABEL": "Solde insuffisant attendu"
                        },
                        "UNEXPECTED_INCOME_LOSS": {
                            "LABEL": "Perte inattendue de revenu"
                        },
                        "RECURRING_EXPENSE_MISSING": {
                            "LABEL": "Paiement attendu manquant"
                        },
                        "NEW_RECURRING_EXPENSES": {
                            "LABEL": "Nouvelle dette détectée"
                        },
                        "DOCUMENT_PAYMENT_REQUEST": {
                            "LABEL": "Demande de paiement"
                        },
                        "YEARLY_REPORT_DUE": {
                            "LABEL": "Le rapport annuel doit être remis"
                        },
                        "FINAL_REPORT_DUE": {
                            "LABEL": "Le rapport final doit être remis"
                        }
                    }
                }
            },
            "TABLE": {
                "COLUMN": {
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    }
                }
            },
            "PROCESS_NOTIFICATIONS": {
                "DIALOG": {
                    "TITLE": "Fermer les notifications"
                },
                "ALL": "Êtes-vous sûr de vouloir fermer toutes les notifications ouvertes pour tous les clients ?",
                "TYPE": "Êtes-vous sûr de vouloir fermer toutes les notifications ouvertes de ce type pour tous les clients ?",
                "WARNING": "Cette action ne peut être annulée qu'en rouvrant les notifications une par une."
            }
        },
        "OFFICE": {
            "HEADER": {
                "LABEL": "Mon bureau"
            }
        },
        "PAYMENTS": {
            "HEADER": {
                "LABEL": "Paiements"
            },
            "FILTER": {
                "STATUS": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Tous les paiements"
                        },
                        "NOT_SUBMITTED": {
                            "LABEL": "Dans la file d'attente"
                        },
                        "SUBMITTED": {
                            "LABEL": "Soumis"
                        },
                        "NOT_PROCESSED": {
                            "LABEL": "En cours de validation"
                        },
                        "PROCESSED_WARNING": {
                            "LABEL": "Avertissement de validation"
                        },
                        "PROCESSED_ERROR": {
                            "LABEL": "Erreur de validation"
                        },
                        "PROCESSED_OK": {
                            "LABEL": "Validé"
                        },
                        "PAID": {
                            "LABEL": "Payé"
                        }
                    }
                }
            },
            "BUTTON": {
                "SUBMIT": {
                    "LABEL": "Soumettre la file d'attente"
                },
                "ADD": {
                    "LABEL": "Ajouter un paiement"
                },
                "SUBMIT_SELECTION": {
                    "LABEL": "Soumettre la sélection"
                },
                "REQUEUE": {
                    "LABEL": "Remettre en file d'attente"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "AMOUNT": {
                        "HEADER": {
                            "LABEL": "Montant"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    },
                    "ACCOUNT": {
                        "HEADER": {
                            "LABEL": "Compte"
                        }
                    },
                    "COUNTERPART": {
                        "HEADER": {
                            "LABEL": "Bénéficiaire"
                        }
                    },
                    "REMITTANCE_INFO": {
                        "HEADER": {
                            "LABEL": "Communication"
                        }
                    },
                    "DATE": {
                        "HEADER": {
                            "LABEL": "Date"
                        }
                    }
                },
                "EMPTY": "Aucune paiement trouvée"
            },
            "NOT_SUPPORTED": "Le compte ne permet pas (plus) les paiements",
            "PREPARE": {
                "SELECTED": "Sélectionnés: {{count}} de {{total}}",
                "NOT_VISIBLE": "{{count}} non visible"
            },
            "DELETE": "Supprimer",
            "EDIT": "Modifier",
            "DELETE_PAYMENT": {
                "QUESTION": "Êtes-vous sûr de vouloir supprimer ce paiement?",
                "DIALOG": {
                    "TITLE": "Supprimer le paiement"
                }
            },
            "REPEAT": "Répéter",
            "DOWNLOAD_DOCUMENT": "Télécharger le document",
            "REQUEST": {
                "KNOWN": "Soumis",
                "UNKNOWN": "File d'attente",
                "STATUS": {
                    "PROCESSING": {
                        "LABEL": "Validation par Isabel 6 en cours"
                    },
                    "WARNING": {
                        "LABEL": "Avertissement dans Isabel 6"
                    },
                    "ERROR": {
                        "LABEL": "Message d'erreur dans Isabel 6"
                    },
                    "VALIDATED": {
                        "LABEL": "Validé par Isabel 6"
                    },
                    "PARTIALLY_PAID": {
                        "LABEL": "Partiellement effectué"
                    },
                    "PAID": {
                        "LABEL": "Effectué"
                    }
                },
                "SUBMITTING": "En cours de soumission"
            },
            "STATUS": {
                "NOT_SUBMITTED": {
                    "LABEL": "Paiement en attente"
                },
                "PROCESSED_WARNING": {
                    "LABEL": "Avertissement lors de la validation du paiement par Isabel 6"
                },
                "PROCESSED_ERROR": {
                    "LABEL": "Message d'erreur lors de la validation du paiement par Isabel 6"
                },
                "PROCESSED_OK": {
                    "LABEL": "Paiement validé par Isabel 6"
                },
                "PAID": {
                    "LABEL": "Paiement effectué"
                },
                "NOT_PROCESSED": {
                    "LABEL": "Validation par Isabel 6 en cours"
                },
                "SUBMITTED": {
                    "LABEL": "Soumis à Isabel 6"
                },
                "SUBMITTING": {
                    "LABEL": "En cours de soumission"
                }
            },
            "FILTERS": {
                "STATUS": {
                    "LABEL": "Statut"
                },
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Recherche"
                },
                "CLIENT": {
                    "LABEL": "Client"
                },
                "COUNTERPART": {
                    "LABEL": "Bénéficiaire"
                },
                "DATE": {
                    "TITLE": "date de mise en œuvre prévue"
                }
            },
            "SUBMIT_PAYMENTS": {
                "DIALOG": {
                    "TITLE": "Soumettre les paiements à Isabel 6",
                    "OVERVIEW": {
                        "PAYMENTS": "paiements",
                        "PAYMENT": "paiement"
                    },
                    "POSSIBLE_DUPLICATE_PAYMENTS": {
                        "TITLE": "Doublons potentiels",
                        "DESCRIPTION": "Les paiements suivants sont déjà présents en double dans la file d’attente ou ont été soumis récemment.",
                        "CLIENT": "Client",
                        "ACCOUNT": "Compte",
                        "COUNTERPART": "Bénéficiaire",
                        "REMITTANCE_INFORMATION": "Communication",
                        "QUEUED": "x dans la file d'attente",
                        "SUBMITTED_AT": "Soumis le",
                        "EXECUTED_AT": "Exécuté le",
                        "EMPTY": "Aucun doublon n’a été trouvé dans la file d’attente ni parmi les paiements récemment soumis."
                    },
                    "INSUFFICIENT_BALANCES": {
                        "TITLE": "Solde insuffisant",
                        "DESCRIPTION": "Le solde disponible sur les comptes suivants est inférieur au montant total des paiements actuellement en file d’attente.",
                        "CLIENT": "Client",
                        "ACCOUNT": "Compte",
                        "IBAN": "IBAN",
                        "BALANCE": "Solde",
                        "COUNTERPART": "Bénéficiaire",
                        "REMITTANCE_INFORMATION": "Communication",
                        "TOTAL": "TOTAL",
                        "EMPTY": "Le solde actuel de tous les comptes est suffisant pour effectuer les paiements."
                    },
                    "CONFIRM": {
                        "LABEL": "Soumettre les paiements"
                    }
                }
            }
        },
        "PROFILE": {
            "HEADER": {
                "LABEL": "Mon profil"
            }
        },
        "BUTTON": {
            "CONFIRM": {
                "LABEL": "Confirmer"
            },
            "CANCEL": {
                "LABEL": "Annuler"
            },
            "EXPORT": {
                "LABEL": "Exporter"
            },
            "ADD": {
                "LABEL": "Ajouter"
            },
            "DELETE": {
                "LABEL": "Supprimer"
            },
            "EDIT": {
                "LABEL": "Modifier"
            },
            "CLOSE": {
                "LABEL": "Fermer"
            },
            "NEXT": {
                "LABEL": "Suivant"
            },
            "PREVIOUS": {
                "LABEL": "Retour"
            },
            "SKIP": {
                "LABEL": "Sauter"
            },
            "PROCESS_NOTIFICATIONS": {
                "LABEL": "Fermer les notifications"
            },
            "OK": {
                "LABEL": "OK"
            }
        },
        "BANK_ACCOUNT": {
            "AVAILABLE_BALANCE": {
                "LABEL": "Disponible"
            },
            "SHARE_SETTINGS": {
                "OFFICE": "Visible pour le client:",
                "CLIENT": "Partagé avec vous",
                "BALANCE": "Solde",
                "TRANSACTIONS": "Transactions",
                "INCOMING_TRANSACTIONS": "Transactions entrantes",
                "OUTGOING_TRANSACTIONS": "Transactions sortantes",
                "SHARED_BY": "Partagé par",
                "SHARED_BY_UNKNOWN": "Ancien utilisateur"
            },
            "NO_LINKED_CLIENT": "Liez ce compte à un client nouveau ou existant<br/>pour afficher le solde et les transactions.",
            "LATEST_SYNC": "Synchronisé",
            "BUTTON": {
                "LINK_CLIENT": {
                    "LABEL": "Liér un client"
                },
                "CREATE_CLIENT": {
                    "LABEL": "Créer un client"
                },
                "AUTHORIZE": {
                    "LABEL": "Renouveler autorisation"
                },
                "PAYMENT": {
                    "LABEL": "Nouveau paiement"
                },
                "IMPORT": {
                    "LABEL": "Importer l'historique"
                },
                "SELECT": {
                    "LABEL": "Sélectionner"
                }
            },
            "WARNING": {
                "AUTH_INVALID": "L'autorisation pour ce compte n'est plus valide.<br>Pour reprendre la synchronisation, l'autorisation doit être renouvelée.",
                "EXPIRING": "L'autorisation pour ce compte expire le {{ date }}.<br>Pour éviter toute interruption de la synchronisation, l'autorisation doit être renouvelée à temps.",
                "TECHNICAL_FAILURE": "Problème technique<br>En raison d'un problème technique à {{ bank }}, la synchronisation est temporairement impossible.",
                "ARCHIVED": "Ce compte a été archivé le {{ date }}",
                "MOVED_TO_ISABEL_ACTIVE": "Le lien avec {{ bank }} a été migré vers Isabel 6.<br>La synchronisation prendra fin le {{ date }}, à moins que ce compte ne puisse être récupéré via Isabel Connect d'ici là.",
                "MOVED_TO_ISABEL_INACTIVE": "Le lien avec {{ bank }} a été migré vers Isabel 6.<br>La synchronisation reprendra dès que ce compte pourra être récupéré via Isabel Connect.",
                "NOT_FOUND_IN_ISABEL": "Ce compte n'est plus disponible via Isabel Connect.<br>La synchronisation reprendra dès que ce compte pourra de nouveau être récupéré via Isabel Connect.",
                "BLOCKED": "Ce compte a été ajouté par un utilisateur de l’application client qui a depuis été bloqué.<br/>La synchronisation n’est plus effectuée."
            },
            "TABLE": {
                "COLUMN": {
                    "CATEGORY": {
                        "HEADER": {
                            "LABEL": "Catégorie"
                        },
                        "CREDITOR": "Créancier",
                        "INTRADAY": {
                            "LABEL": "Transaction intrajournalière",
                            "INFO": "Les transactions intrajournalières ne peuvent pas encore être modifiées car elles ne sont pas encore finalisées."
                        }
                    },
                    "COUNTERPART": {
                        "HEADER": {
                            "LABEL": "Contrepartie"
                        }
                    },
                    "DETAILS": {
                        "HEADER": {
                            "LABEL": "Détails"
                        },
                        "REMITTANCE_INFO": "Communication",
                        "COUNTERPART": {
                            "FROM": "A partir de",
                            "TO": "Pour"
                        },
                        "VALUE_DATE": "Date de valeur",
                        "INTERNAL_NOTE": "Note interne"
                    },
                    "AMOUNT": {
                        "HEADER": {
                            "LABEL": "Montant"
                        }
                    },
                    "TAGS": {
                        "HEADER": {
                            "LABEL": "Étiquettes"
                        }
                    }
                },
                "EMPTY": "Aucune transaction trouvée",
                "ACTIONS": {
                    "REPEAT": "Payer à nouveau",
                    "DOWNLOAD": "Télécharger le document",
                    "UPLOAD_DOCUMENT": "Téléverser un document"
                },
                "NOTIFICATIONS_ONLY": "Seules les notifications sont partagées pour ce compte."
            },
            "FILTERS": {
                "CATEGORY": {
                    "TITLE": "Catégorie",
                    "UNCATEGORIZED": "Sans catégorie",
                    "MULTIPLE": "Plusieurs catégories"
                },
                "DATE": {
                    "TITLE": "Date de mise en œuvre"
                },
                "COUNTERPART": {
                    "VALUE": {
                        "NAME": "Nom contient \"{{counterpart}}\"",
                        "REFERENCE": "IBAN contient \"{{counterpart}}\""
                    },
                    "TITLE": "Contrepartie",
                    "NAME": "Nom contient",
                    "REFERENCE": "IBAN contient"
                },
                "REMITTANCE_INFO": {
                    "TITLE": "Communication",
                    "CONTAINS": "Communication contient",
                    "VALUE": "Communication contient \"{{remittanceInfo}}\""
                },
                "TYPE": {
                    "TITLE": "Type",
                    "CONTAINS": "Type contient",
                    "VALUE": "Type contient \"{{description}}\""
                },
                "AMOUNT": {
                    "TITLE": "Montant",
                    "MIN": "Minimum",
                    "MAX": "Maximum",
                    "VALUE": {
                        "MIN": "≥ {{amountMin}}",
                        "BETWEEN": "{{amountMin}} – {{amountMax}}",
                        "MAX": "≤ {{amountMax}}"
                    },
                    "ALL": "Entrants & sortants",
                    "DEBIT": "Sortants",
                    "CREDIT": "Entrants"
                },
                "TAGS": {
                    "MULTIPLE": "Plusieurs étiquettes",
                    "TITLE": "Étiquettes"
                },
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Recherche"
                }
            },
            "EDIT_CLIENT_SETTINGS": {
                "TITLE": "Paramètres du client",
                "LINKED_CLIENT": {
                    "HEADER": "Client lié"
                },
                "TYPE": {
                    "HEADER": "Type de compte"
                },
                "SELECT_CLIENT": "Sélectionner un client",
                "NO_CLIENT": "Aucun"
            },
            "EDIT_TRANSACTION_CATEGORY": {
                "TITLE": "Catégorie",
                "APPLY_TO": "Postuler à",
                "TRANSACTION": {
                    "TO": "Pour",
                    "REMITTANCE_INFO": "Communication"
                },
                "CREDITOR": "Créancier",
                "TYPES": {
                    "INCOMING": {
                        "TRANSACTION": "Seulement cette transaction",
                        "ACCOUNT": "Tous les revenus de <u>ce compte</u> qui satisfont",
                        "CLIENT": "Tous les revenus de <u>ce client</u> qui satisfont",
                        "ALL_CLIENTS": "Tous les revenus de <u>tous les clients</u> qui satisfont"
                    },
                    "OUTGOING": {
                        "TRANSACTION": "Seulement cette transaction",
                        "ACCOUNT": "Toutes les dépenses de <u>ce compte</u> qui satisfont",
                        "CLIENT": "Toutes les dépenses de <u>ce client</u> qui satisfont",
                        "ALL_CLIENTS": "Toutes les dépenses de <u>tous les clients</u> qui satisfont"
                    }
                },
                "FILTERS": {
                    "COUNTERPART_REFERENCE": "La référence de la contrepartie est",
                    "COUNTERPART_NAME": "La contrepartie contient",
                    "REMITTANCE_INFO": "La communication contient",
                    "DATE_FROM": "Date est au plus tô",
                    "DATE_TO": "Date au plus tard",
                    "AMOUNT_MIN": "Le montant est minimum",
                    "AMOUNT_MAX": "Le montant est maximal",
                    "DESCRIPTION": "Type contient",
                    "CATEGORY": "La catégorie est"
                },
                "ADD_CATEGORY": "Nouvelle catégorie",
                "MAIN_CATEGORY": "Catégorie principale",
                "NEW_SUB_CATEGORY": {
                    "TITLE": "Nouvelle sous-catégorie",
                    "ERROR": {
                        "REQUIRED": "Exigée",
                        "DUPLICATE": "déjà ajoutée"
                    }
                },
                "CATEGORY": {
                    "ERROR": {
                        "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                        "DUPLICATE": "Catégorie a déjà été ajouté",
                        "MIN": "Seuls les nombres positifs sont autorisés",
                        "FILTER_REQUIRED": "Sélectionner au moins un filtre"
                    },
                    "SELECT": "Sélectionnez une catégorie"
                },
                "ADD_CATEGORY_NOTICE": "Les catégories personnalisées seront disponibles pour tous les clients."
            },
            "EDIT_TRANSACTION_DETAILS": {
                "TRANSACTION": {
                    "TITLE": "Transaction"
                }
            },
            "SET_ARCHIVED_STATUS": {
                "DIALOG": {
                    "STATUS": {
                        "TITLE": "Statut",
                        "ARCHIVED": "Archivé le {{ date }}",
                        "ACTIVE": "Actif"
                    },
                    "TITLE": "Archiver",
                    "ACTION": {
                        "TITLE": "Action",
                        "ARCHIVED": "Rétablir",
                        "ACTIVE": "Archiver"
                    },
                    "INFO": {
                        "ARCHIVED": "Le rétablissement d'un compte bancaire implique :\n<ul>\n<li>Le compte est réaffiché dans la liste des comptes actifs.</li>\n<li>Le compte peut être rattaché à un client (différent).</li>\n<li>Il est à nouveau possible de modifier la catégorie et les étiquettes d'une transaction.</li>\n<li>Si le compte est disponible via Isabel Connect, la synchronisation reprend automatiquement.</li>\n<li>Si le compte a été ajouté directement par la banque, l'autorisation doit être renouvelée.</li>\n<li><b>ATTENTION : Si le compte a été archivé pendant une longue période, il se peut que l'historique ne puisse pas être entièrement complété !</b></li>\n</ul>",
                        "ACTIVE": "Archiver un compte bancaire implique :\n<ul>\n<li>Le compte n'apparaît plus dans la liste des comptes actifs.</li>\n<li>Le compte ne peut plus être lié à un client.</li>\n<li>Si le compte est déjà lié à un client, il restera visible auprès de ce client.</li>\n<li>La catégorie et les étiquettes d'une transaction ne peuvent plus être modifiées.</li>\n<li>Les transactions ne sont plus synchronisées et le solde n'est plus disponible.</li>\n</ul>",
                        "NOT_RESTORABLE": "Ce compte ne peut pas être rétabli :\n<ul>\n<li>Le compte est lié à un client archivé.</li>\n<li>Pour rétablir le compte, il faut d'abord rétablir le client lié.</li>\n</ul>"
                    }
                }
            },
            "EDIT_TRANSACTION_TAGS": {
                "TITLE": "Étiquettes",
                "ADD_TAG_NOTICE": "Les étiquettes sont disponibles pour chaque client séparément.",
                "NEW_TAG": "Nouvelle étiquette",
                "ERROR": {
                    "DUPLICATE": "déjà ajoutée",
                    "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                    "MIN": "Seuls les nombres positifs sont autorisés",
                    "FILTER_REQUIRED": "Sélectionner au moins un filtre"
                }
            },
            "SELECTED": {
                "SINGULAR": "1 transaction sélectionnée",
                "PLURAL": "{{count}} transactions sélectionnées",
                "SUM": {
                    "BALANCE": "total",
                    "INCOME": "entrant",
                    "EXPENSES": "sortant"
                }
            }
        },
        "FILTER": {
            "TITLE": "Filtrer par",
            "SET": "Valider"
        },
        "FILTERS": {
            "DATE": {
                "TITLE_SHORT": "Date",
                "FROM": "À partir de",
                "TO": "Jusqu'à et y compris",
                "VALUE": {
                    "FROM": "À partir de {{dateFrom}}",
                    "TO": "Jusqu'à {{dateTo}} inclus",
                    "FROM_TO": "{{dateFrom}} – {{dateTo}}"
                }
            }
        },
        "TABLE": {
            "COLLAPSE_ALL": "Réduire tous",
            "EXPAND_ALL": "Ouvrir tous"
        },
        "DOCUMENTS": {
            "TABLE": {
                "COLUMN": {
                    "DOCUMENT": {
                        "HEADER": {
                            "LABEL": "Document"
                        }
                    },
                    "DATE": {
                        "HEADER": {
                            "LABEL": "Date"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Client"
                        }
                    }
                },
                "EMPTY": "Aucun document trouvé"
            },
            "TYPE": {
                "DOCUMENT": "Document",
                "IMAGE": "Image",
                "FINANCIAL_REPORT": "Rapport financier",
                "YEARLY_DEBT_REPORT": "Rapport annuel RCD",
                "FINAL_DEBT_REPORT": "Rapport final RCD",
                "YEARLY_REPORT_XLSX_GUARDIANSHIP": "Rapport annuel de l’administration",
                "YEARLY_OVERSIGHT_REPORT": "Livre journal",
                "ARCHIVE": "Archives",
                "HONORARIUM_GUARDIANSHIP": "Taxation",
                "ACTIVE_DOSSIERS_DEBT_REPORT": "Vue d'ensemble des dossiers RCD en cours",
                "EMAIL": "E-mail",
                "YEARLY_OVERSIGHT_REPORT_WITH_DOCUMENTS": "Livre journal avec pièces justificatives",
                "HONORARIUM_DEBT_MEDIATION": "Taxation RCD"
            },
            "GENERATED_BY": "Généré par",
            "ADDED_BY": "Téléchargé par",
            "SYSTEM_USER": "ROOV",
            "SHARED_WITH_CLIENT": "Partagé avec le client",
            "HIDDEN": "Caché",
            "FILTER": {
                "SHOW_HIDDEN": {
                    "LABEL": "Montrer caché"
                }
            },
            "FILTERS": {
                "TYPE": {
                    "MULTIPLE": "Plusieurs types",
                    "LABEL": "Type"
                },
                "OWNER": {
                    "LABEL": "Propriétaire",
                    "MULTIPLE": "Propriétaires multiples"
                },
                "CLIENT": {
                    "LABEL": "Client"
                }
            },
            "BUTTON": {
                "GENERATE": {
                    "LABEL": "Generer"
                },
                "UPLOAD": {
                    "LABEL": "Importer"
                },
                "PROCESS_ALL": {
                    "LABEL": "Traiter tout"
                },
                "SELECT": {
                    "LABEL": "Sélectionner"
                },
                "SELECT_ALL": {
                    "LABEL": "Sélectionner tout"
                },
                "PAY": {
                    "LABEL": "Payer"
                },
                "ASSIGN": {
                    "LABEL": "Attribuer"
                },
                "DELETE": {
                    "LABEL": "Supprimer"
                },
                "MOVE": {
                    "LABEL": "Réattribuer"
                },
                "EMAIL": {
                    "LABEL": "Ajouter via e-mail"
                }
            },
            "DROP": "Déposez vos documents ici",
            "EXTENSIONS": "Types de fichiers acceptés",
            "UPLOAD_LIMITS": "Maximum 20MB par fichier et 200MB au total.",
            "RENAME": "Renommer",
            "DELETE": "Supprimer",
            "HIDE": "Cacher",
            "MAKE_VISIBLE": "Rendre visible",
            "SHARE": "Partager",
            "STOP_SHARING": "Cesser de partager",
            "CREATE_PAYMENT": "Payer",
            "EDIT_PAYMENT": "Modifier le paiement",
            "REPEAT_PAYMENT": "Payer à nouveau",
            "HEADER": {
                "LABEL": "Documents"
            },
            "ACTIVE_DEBT_DOSSIERS_REPORT": {
                "CREATE_SOON": "Générez ici à partir du 1er juillet la vue d'ensemble avec le statut au 30/06 des dossiers RCD en cours.",
                "CREATE_NOW": "Générez maintenant la vue d'ensemble avec le statut au 30/06 des dossiers RCD en cours.",
                "BUTTON": {
                    "LABEL": "Générer"
                },
                "LABOUR_COURT": {
                    "PLACEHOLDER": "Sélectionnez un tribunal du travail"
                }
            },
            "UNPROCESSED": "À traiter",
            "PROCESSED": "Traités",
            "ASSIGN": "Attribuer",
            "SELECTED": {
                "SINGULAR": "1 document sélectionné",
                "PLURAL": "{{count}} documents sélectionnés"
            },
            "MOVE": "Réattribuer",
            "ADDED_BY_EMAIL": "Ajouté via e-mail de",
            "ADDED_BY_EMAIL_OWNER": "Ajouté via e-mail par",
            "EMAIL": {
                "DIALOG": {
                    "TITLE": "Ajouter des documents via e-mail",
                    "FIRST_LINE": "Ajoutez des documents en les envoyant en pièce jointe à l'adresse e-mail suivante :",
                    "ADDITIONAL_INFO": "Les documents supportés envoyés à cette adresse en pièces jointes seront ajoutés aux documents à traiter.",
                    "BUTTON": {
                        "COPY": {
                            "LABEL": "Copier l’adresse"
                        }
                    }
                }
            },
            "DOWNLOAD": "Télécharger",
            "SHARED_BY_CLIENT": "Partagé depuis l'application client"
        },
        "ADD_PAYMENT_DIALOG": {
            "TITLE": "Nouveau paiement",
            "FROM": {
                "HEADER": "A partir de",
                "CLIENT": {
                    "TITLE": "Client",
                    "NO_CLIENT": "Sélectionner un client"
                },
                "ACCOUNT": {
                    "TITLE": "Compte",
                    "NO_ACCOUNT": "Sélectionner un compte"
                }
            },
            "TO": {
                "HEADER": "Pour",
                "BENEFICIARY": {
                    "TITLE": "Bénéficiaire",
                    "NO_BENEFICIARY": "Sélectionner un bénéficiaire",
                    "NO_EDIT_CREDITOR": "Créancier lié au client. Il n'est pas possible d'éditer ici.",
                    "NO_EDIT_BANK_ACCOUNT": "Compte bancaire lié au client. Il n'est pas possible d'éditer ici.",
                    "NAME": "Nom",
                    "IBAN": "IBAN",
                    "SINGLE_USE": "Usage unique",
                    "CLIENT": "Sauvegarder pour le client",
                    "GLOBAL": "Sauvegarder globalement",
                    "ADD_BENEFICIARY": "Nouveau bénéficiaire"
                }
            },
            "DATA": {
                "HEADER": "Coordonnées",
                "AMOUNT": {
                    "TITLE": "Montant"
                },
                "REMITTANCE_INFO": {
                    "TITLE": "Communication"
                },
                "EXECUTION_DATE": {
                    "TITLE": "Date de mise en œuvre"
                }
            },
            "ERROR": {
                "REMITTANCE_INFORMATION": "Communication non valide",
                "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                "MAT_DATEPICKER_MIN": "La date d'exécution ne doit pas se situer dans le passé",
                "MAT_DATEPICKER_PARSE": "Date non valide",
                "MIN": "Le montant doit être supérieur à 0",
                "EDITING": "Le bénéficiaire doit être gardé en premier",
                "IBAN": "IBAN non valide",
                "UNIQUE": "Il existe déjà un compte avec cet IBAN",
                "BENEFICIARY_NAME": "Nom non valide",
                "SAME_IBAN": "Le numéro de compte du bénéficiaire est égal au numéro de compte du paiement",
                "MAT_DATEPICKER_MAX": "La date d'exécution ne doit pas se situer plus d'un an dans le futur",
                "DOCUMENT_NAME_EDITING": "Le nom doit d'abord être enregistré"
            },
            "ANOTHER_PAYMENT": "Ajouter un autre paiement",
            "WARNING": {
                "DUPLICATE_PAYMENT_EXECUTED": "Un paiement similaire a déjà été effectué le {{date}}",
                "DUPLICATE_PAYMENT_SUBMITTED": "Un paiement similaire a déjà été soumis le {{date}}",
                "DUPLICATE_PAYMENT_QUEUED": "Un paiement similaire est déjà en attente"
            },
            "ANOTHER_PAYMENT_DESCRIPTION": "Les champs sélectionnés sont copiés.",
            "INTERNAL_NOTE": {
                "TITLE": "Note interne",
                "DESCRIPTION": "Disponible uniquement dans ROOV Business.",
                "PLACEHOLDER": "Note interne"
            }
        },
        "DOCUMENT": {
            "RENAME_DOCUMENT": {
                "DIALOG": {
                    "TITLE": "Renommer le document",
                    "ERROR": {
                        "REQUIRED": "Saisissez un nom"
                    }
                },
                "NAME": {
                    "LABEL": "Nom",
                    "PLACEHOLDER": "Nom sans extension de fichier"
                }
            },
            "DELETE_DOCUMENT": {
                "DIALOG": {
                    "TITLE_SINGLE": "Supprimer le document",
                    "QUESTION_SINGLE": "Êtes-vous sûr de vouloir supprimer ce document ?",
                    "INFO_SINGLE": "Si le document est partagé, il est également supprimé pour le client. Cette action ne peut être annulée.",
                    "TITLE_MULTI": "Supprimer les documents",
                    "QUESTION_MULTI": "Êtes-vous sûr de vouloir supprimer ces documents ?",
                    "INFO_MULTI": "Si un document est partagé, il est également supprimé pour le client. Cette action ne peut être annulée."
                }
            },
            "ASSIGN_DOCUMENT": {
                "DIALOG": {
                    "TITLE_SINGLE": "Attribuer le document à un client",
                    "ASSIGN_TO": "Attribuer à",
                    "ERROR": {
                        "REQUIRED": "Sélectionnez un client",
                        "DOCUMENT_NAME_EDITING": "Le nom doit d'abord être enregistré"
                    },
                    "TITLE_MULTI": "Attribuer les documents à un client",
                    "SELECTED_DOCUMENTS": "Documents sélectionnés"
                }
            },
            "VIEW_DOCUMENT": {
                "DIALOG": {
                    "TITLE": "Document"
                }
            }
        },
        "CLIENT": {
            "CLIENT_APP": {
                "STATUS": {
                    "NOT_SENT": "Envoyez une invitation par e-mail ou fournissez le code personnel.",
                    "SENT": "Une invitation a été envoyée par e-mail le {{date}}.",
                    "CLAIMED": "Le lien vers le compte mobile a été établi le {{date}}.",
                    "REVOKED": "Le lien vers le compte mobile a été déconnecté le {{date}}."
                },
                "CODE": {
                    "TITLE": "Code personnel",
                    "MESSAGE": "La saisie de ce code dans l'application mobile ROOV permet de lier le compte mobile à ce client."
                },
                "INFO": {
                    "TITLE": "Grâce à l'application mobile ROOV, des informations peuvent être échangées entre vous et le client.",
                    "FEATURE_1": "Vous aurez accès au(x) compte(s) ajouté(s) par le client. Pour chaque compte, le client choisit de partager le solde et/ou les transactions. En cas de problème (potentiel), vous recevrez une notification.",
                    "FEATURE_2": "Le client a accès au(x) compte(s) que vous gérez pour lui. Vous pouvez définir quelles informations sont partagées pour chaque compte.",
                    "FEATURE_3": "Vous pouvez partager des documents avec le client et vice versa.",
                    "FEATURE_4": "Le client peut demander à payer une facture à partir d'un compte que vous gérez.",
                    "ACCESS": {
                        "TITLE": "Vous décidez si vous donnez accès à ce dossier.",
                        "DESCRIPTION": "Invitez un utilisateur via adresse e-mail ou numéro de GSM. Vous pouvez ensuite bloquer l'utilisateur pour retirer l'accès et éventuellement inviter un autre utilisateur."
                    },
                    "CLIENT_ACCOUNTS": {
                        "TITLE": "Vous pouvez consulter le(s) compte(s) ajouté(s) par l'utilisateur.",
                        "DESCRIPTION": "Pour chaque compte, l'utilisateur choisit quelles informations sont partagées et si vous pouvez recevoir des notifications en cas de problèmes potentiels."
                    },
                    "OFFICE_ACCOUNTS": {
                        "TITLE": "L'utilisateur peut consulter le(s) compte(s) que vous gérez pour ce dossier.",
                        "DESCRIPTION": "Vous pouvez définir quelles informations sont partagées pour chaque compte."
                    },
                    "DOCUMENTS": {
                        "TITLE": "Vous pouvez partager des documents avec l'utilisateur, et inversement.",
                        "OWN_DESCRIPTION": "Vous reconnaissez les documents que vous partagez à cette icône:",
                        "CLIENT_DESCRIPTION": "Les documents partagés avec vous sont reconnaissables à cette icône:"
                    },
                    "PAYMENT_REQUESTS": {
                        "TITLE": "L'utilisateur peut introduire une demande de paiement d'une facture à partir d'un compte que vous gérez.",
                        "DOCUMENT_DESCRIPTION": "La facture apparaît comme document partagé dans la liste.",
                        "NOTIFICATION_DESCRIPTION": "Vous recevez également une notification à partir de laquelle vous pouvez accepter ou refuser la demande et créer le paiement."
                    }
                },
                "ARCHIVED": "Le lien avec un compte mobile n'est possible que pour les clients actifs.",
                "SEND_INVITATION": {
                    "EMAIL": "E-mail du client",
                    "SEND_COPY": "me mettre en copie",
                    "SEND": "Envoyer une invitation",
                    "SEND_AGAIN": "Renvoyer l'invitation"
                },
                "MOBILE_USER": {
                    "ACTIVE_USER": "Utilisateur actif",
                    "LOGIN_METHOD": "Méthode de connexion",
                    "EMAIL": "E-mail",
                    "PHONE": "Numéro de GSM",
                    "INVITE": {
                        "LABEL": "Inviter un utilisateur",
                        "LOADING": "Chargement des utilisateurs",
                        "ERROR": "Les utilisateurs n'ont pas pu être chargés",
                        "ACTIVE_USER": "Il y a déjà un utilisateur actif"
                    }
                },
                "MOBILE_USER_INVITATION_DIALOG": {
                    "TITLE": "Inviter un utilisateur à l'application mobile",
                    "PERSONAL_INFO": "Données personnelles",
                    "LOGIN_INFO": "Informations de connexion",
                    "FIRST_NAME": "Prénom",
                    "LAST_NAME": "Nom de famille",
                    "EMAIL": "Adresse e-mail",
                    "PHONE": "Numéro de GSM",
                    "NO_EMAIL_ACCESS": "Cet utilisateur n'a pas accès à l'e-mail.",
                    "NO_EMAIL_ACCESS_INFO": "Si l'utilisateur n'a pas accès à l'e-mail sur son smartphone, il est possible de se connecter par SMS.",
                    "ERROR": {
                        "REQUIRED": "Vérifiez les champs obligatoires",
                        "EMAIL": "Adresse e-mail invalide",
                        "PATTERN": "Numéro de GSM invalide",
                        "DUPLICATE": "L'utilisateur existe déjà"
                    },
                    "COUNTRY_CODE": "Indicatif du pays",
                    "PHONE_NUMBER": "Numéro de GSM",
                    "COUNTRY": {
                        "BELGIUM": "Belgique",
                        "NETHERLANDS": "Pays-Bas",
                        "FRANCE": "France",
                        "GERMANY": "Allemagne",
                        "LUXEMBOURG": "Luxembourg"
                    }
                }
            }
        },
        "SETTINGS": {
            "HEADER": {
                "LABEL": "Paramètres"
            },
            "TAB": {
                "ACCOUNT": {
                    "LABEL": "Mon compte",
                    "INFO": {
                        "EDIT": {
                            "DIALOG": {
                                "ERROR": {
                                    "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                                    "EMAIL": "L'adresse e-mail n'est pas valide"
                                }
                            }
                        }
                    },
                    "PASSWORD": {
                        "EDIT": {
                            "DIALOG": {
                                "ERROR": {
                                    "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                                    "DIFFERENT": "Les mots de passe sont différents",
                                    "MINLENGTH": "Minimum 8 caractères"
                                }
                            }
                        }
                    }
                },
                "OFFICE": {
                    "LABEL": "Mon bureau",
                    "EDIT": {
                        "DIALOG": {
                            "ERROR": {
                                "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                                "IBAN": "IBAN non valide",
                                "COMPANY_NUMBER": "Numéro d’entreprise non valide"
                            }
                        }
                    }
                },
                "USERS": {
                    "LABEL": "Utilisateurs"
                },
                "ISABEL_CONNECT": {
                    "LABEL": "Isabel Connect",
                    "CONNECTED": "Isabel Connect est actif",
                    "INFO": {
                        "TITLE": "Avec Isabel Connect, vous établissez une connexion entre ROOV Business et Isabel 6.",
                        "FEATURE_1": "Pour utiliser Isabel Connect, une seule installation suffit.",
                        "FEATURE_2": "Tous les comptes de votre compte Isabel 6 sont automatiquement disponibles dans ROOV Business.",
                        "FEATURE_3": "Vous pouvez préparer les paiements dans Isabel 6 de ROOV Business."
                    },
                    "CONNECT": "Mise en place d'Isabel Connect"
                },
                "CATEGORIES": {
                    "LABEL": "Catégories"
                }
            },
            "ACCOUNT": {
                "PERSONAL_INFO": {
                    "HEADER": "Données personnelles",
                    "FIRSTNAME": "Prénom",
                    "LASTNAME": "Nom",
                    "EMAIL": "E-mail"
                },
                "PASSWORD": {
                    "HEADER": "Mot de passe",
                    "INFO": "La connexion à ROOV Business se fait à l'aide de votre adresse électronique et d'un mot de passe.",
                    "EDIT": {
                        "TITLE": "Modifier mot de passe"
                    },
                    "OLD_PASSWORD": {
                        "HEADER": "Saisissez votre mot de passe actuel pour en définir un nouveau",
                        "LABEL": "Mot de passe actuel"
                    },
                    "NEW_PASSWORD": {
                        "HEADER": "Choisissez un nouveau mot de passe",
                        "LABEL": "Nouveau mot de passe",
                        "CONFIRM_PASSWORD": "Répète mot de passe"
                    }
                }
            },
            "OFFICE": {
                "GENERAL": {
                    "HEADER": "Infos générales",
                    "NAME": "Nom du bureau",
                    "LANGUAGE": "Langue",
                    "ADDRESS": {
                        "STREET": "Rue",
                        "NUMBER": "No / boîte",
                        "POSTAL_CODE": "Code postal",
                        "CITY": "Municipalité"
                    },
                    "COMPANY_NUMBER": "Numéro d’entreprise"
                },
                "BANK_ACCOUNTS": {
                    "HEADER": "Comptes bancaires",
                    "PREFIX": "Cela permet de reconnaître les transactions entre le client et vous et de les classer automatiquement dans la bonne catégorie.",
                    "IBAN": "IBAN",
                    "ADD_ACCOUNT": "Ajouter un compte"
                },
                "COURTS": {
                    "HEADER": "Tribunaux",
                    "PREFIX": "Le tribunal par défaut défini ici est pris en compte pour les clients pour lesquels aucun tribunal n'a été défini.",
                    "JUSTICE_PEACE": "Justice de paix par défaut",
                    "LABOUR_COURT": "Tribunal de travail par défaut",
                    "NO_JUSTICE_PEACE": "Pas de justice de paix par défaut",
                    "NO_LABOUR_COURT": "Pas de tribunal de travail par défaut"
                },
                "LOGO": {
                    "HEADER": "Logo",
                    "ADD": "Ajouter un logo",
                    "EDIT": "Changer le logo",
                    "CLEAR": "Supprimer le logo"
                },
                "CC_ACCESS": {
                    "HEADER": "Accès à mon bureau",
                    "TOGGLE": {
                        "LABEL": "Autoriser ROOV à accéder à mon bureau pour le support technique"
                    },
                    "NOT_GRANTED": "Aucune autorisation n'a été accordée.",
                    "GRANTED": "L'autorisation a été accordée par {{ user }} le {{ date }}.",
                    "REVOKED": "L'autorisation a été retirée par {{ user }} le {{ date }}."
                }
            },
            "USERS": {
                "FILTER": {
                    "SHOW_BLOCKED": {
                        "LABEL": "Utilisateurs bloqués"
                    }
                },
                "COLUMN": {
                    "NAME": {
                        "HEADER": "Nom"
                    },
                    "EMAIL": {
                        "HEADER": "E-mail"
                    },
                    "DEFAULT": {
                        "HEADER": "Fonction par défaut"
                    }
                },
                "DEFAULT": {
                    "ADMINISTRATOR": "Administrateur",
                    "DEBT_MEDIATOR": "Médiateur de dettes"
                },
                "BLOCKED": "Bloqué(e)",
                "ACTIONS": {
                    "EDIT": "Éditer",
                    "SET_DEFAULT_ADMINISTRATOR": "Administrateur par défaut",
                    "SET_DEFAULT_DEBT_MEDIATOR": "Médiateur de lat dette par défaut",
                    "BLOCK": "Bloquer",
                    "UNBLOCK": "Débloquer",
                    "REVOKE_INVITATION": "Révoquer l’invitation"
                },
                "BUTTON": {
                    "ADD": {
                        "LABEL": "Inviter un utilisateur"
                    }
                },
                "DIALOG": {
                    "ADD": {
                        "TITLE": "Nouvel utilisateur"
                    },
                    "EDIT": {
                        "TITLE": "Modifier l'utilisateur"
                    },
                    "ERROR": {
                        "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                        "EMAIL": "L'adresse e-mail n'est pas valide"
                    }
                },
                "PERSONAL": {
                    "TITLE": "Données personnelles",
                    "FIRSTNAME": "Prénom",
                    "LASTNAME": "Nom",
                    "EMAIL": "E-mail"
                },
                "ROLE": {
                    "TITLE": "Rôle de l'utilisateur",
                    "ADMIN": {
                        "LABEL": "Admin.",
                        "DESCRIPTION": "Ce rôle permet de gérer les utilisateurs de ce bureau"
                    }
                },
                "EMPTY": "Aucun utilisateur trouvé",
                "INVITED": "Invité"
            },
            "CATEGORIES": {
                "LABEL": "Catégories",
                "BUTTON": {
                    "ADD": "Ajouter une catégorie"
                },
                "FILTERS": {
                    "MAIN": {
                        "ALL": "Toutes les catégories principales"
                    },
                    "CUSTOM": {
                        "LABEL": "Uniquement les catégories personnalisées"
                    },
                    "MAPPING": {
                        "NONE": "Sélectionnez un arrondissement"
                    }
                },
                "ACTIONS": {
                    "EDIT": "Modifier",
                    "DELETE": "Supprimer"
                },
                "MAIN": {
                    "LABEL": "Catégorie principale"
                },
                "SUB": {
                    "LABEL": "Sous-catégorie"
                },
                "TABLE": {
                    "EMPTY": "Aucune catégorie trouvée"
                },
                "DIALOG": {
                    "ADD": {
                        "TITLE": "Nouvelle catégorie",
                        "CATEGORY": {
                            "TITLE": "Catégorie"
                        }
                    },
                    "ERROR": {
                        "REQUIRED": "La catégorie est obligatoire",
                        "DUPLICATE": "Cette catégorie existe déjà"
                    },
                    "EDIT": {
                        "TITLE": "Modifier la catégorie",
                        "CATEGORY": {
                            "TITLE": "Catégorie"
                        }
                    },
                    "DELETE": {
                        "TITLE": "Supprimer la catégorie",
                        "CATEGORY": {
                            "TITLE": "Catégorie"
                        },
                        "REASSIGN": {
                            "TITLE": "Recatégorisation des transactions",
                            "DETAILS": "attribuer les {{ count }} transactions ayant cette catégorie à :",
                            "CATEGORY": {
                                "PLACEHOLDER": "Sélectionnez une catégorie"
                            },
                            "DETAILS_EMPTY": "Aucune transaction n'utilise cette catégorie",
                            "DETAILS_SINGLE": "attribuer la 1 transaction ayant cette catégorie à :"
                        },
                        "USED_IN_CLIENT_BUDGET": {
                            "TITLE": "Incluse dans des plans budgétaires",
                            "INFO": "Cette catégorie est incluse dans les plans budgétaires des clients listés ci-dessous et ne peut donc pas être supprimée."
                        }
                    }
                },
                "MAPPING": {
                    "LABEL": "Catégories correspondantes pour le reporting",
                    "CRBP": {
                        "LABEL": "RCPP"
                    },
                    "HONORARIUM": {
                        "LABEL": "Honoraires"
                    }
                }
            }
        },
        "EDIT_PAYMENT_DIALOG": {
            "TITLE": "Modifier le paiement"
        },
        "XS2A": {
            "TITLE": "Ajouter des comptes / renouveler l'autorisation",
            "FINANCIAL_INSTITUTION": {
                "TITLE": "Banque"
            },
            "INSTRUCTIONS": {
                "TITLE": "Instructions",
                "REDIRECT_TO_BANK": "Lorsque vous cliquez sur « Confirmer », vous êtes redirigé vers le portail de la banque.",
                "AUTHENTICATE": "Connectez-vous à la banque (lecteur de carte, itsMe...).",
                "SELECT_ALL": "Sélectionnez tous les comptes que vous souhaitez synchroniser avec ROOV Business (nouveaux et déjà ajoutés).",
                "SELECT_ONE": "Sélectionnez le compte que vous souhaitez ajouter au ROOV Business ou pour lequel vous souhaitez renouveler l'autorisation.",
                "CONFIRM_SELECTION": "Confirmez votre sélection.",
                "CONFIRM_GLOBAL": "Confirmez l'accès à tous les comptes.",
                "REDIRECT_TO_ROOV": "Vous serez ramené à ROOV Business.",
                "SELECT_FINANCIAL_INSTITUTION": "Sélectionnez la banque",
                "GKCCBEBB": "Sélectionnez les comptes (100 au maximum) que vous souhaitez ajouter ou pour lesquels vous souhaitez renouveler l'autorisation.",
                "GEBABEBB": "Sélectionnez les comptes pour lesquels vous souhaitez ajouter ou renouveler l'autorisation.",
                "BBRUBEBB": "Sélectionnez les comptes (50 au maximum) que vous souhaitez ajouter ou pour lesquels vous souhaitez renouveler l'autorisation.",
                "CLICK_NEXT": "Cliquez sur « Suivant ». Un formulaire vous est présenté.",
                "ENTER_CUSTOMER_REFERENCE": "Si cela vous est demandé, saisissez le numéro de client de votre banque.",
                "ENTER_IBANS": "Saisissez les IBAN des nouveaux comptes que vous souhaitez ajouter (laissez le champ vide si vous souhaitez uniquement renouveler l'autorisation des comptes précédemment ajoutés).",
                "CONFIRM_TO_REDIRECT_TO_BANK": "Cliquez sur « Confirmer ». Vous serez redirigé vers le portail de la banque.",
                "CONFIRM_DETAILED": "Confirmez que vous autorisez ROOV / Augias Corp. à accéder aux comptes.",
                "ENTER_IBANS_FOR_IMPORT": "Sélectionnez les IBAN des comptes pour lesquels vous souhaitez importer l'historique.",
                "SELECT_ALL_FOR_IMPORT": "Sélectionnez les comptes pour lesquels vous souhaitez importer l'historique, ainsi que les comptes que vous souhaitez maintenir synchronisés.",
                "SELECT_ONE_FOR_IMPORT": "Sélectionnez le compte pour lequel vous souhaitez importer l'historique.",
                "GKCCBEBB_FOR_IMPORT": "Sélectionnez les comptes (100 au maximum) pour lesquels vous souhaitez importer l'historique.",
                "GEBABEBB_FOR_IMPORT": "Sélectionnez les comptes pour lesquels vous souhaitez importer l'historique.",
                "BBRUBEBB_FOR_IMPORT": "Sélectionnez les comptes (50 au maximum) pour lesquels vous souhaitez importer l'historique."
            },
            "IMPORTANT": {
                "TITLE": "Important",
                "FINANCIAL_INSTITUTION_OFFERED_1": "Ne vous contentez pas de sélectionner les nouveaux comptes que vous souhaitez ajouter ou les comptes pour lesquels vous souhaitez renouveler l'autorisation. Sélectionnez tous les comptes que vous souhaitez synchroniser avec ROOV Business.",
                "FINANCIAL_INSTITUTION_OFFERED_2": "Si vous ne re-sélectionnez pas un compte que vous avez ajouté auparavant, il ne sera plus synchronisé et obtiendra un statut d'erreur.",
                "GLOBAL": "Avec cette banque, vous ne pouvez pas choisir les comptes à lier. Tous les comptes pour lesquels vous disposez des autorisations nécessaires seront automatiquement ajoutés.",
                "SINGLE_1": "L'autorisation ne peut être accordée que pour un seul compte à la fois.",
                "SINGLE_2": "Répétez la procédure pour chaque compte pour lequel vous souhaitez ajouter ou renouveler une autorisation.",
                "GKCCBEBB_ERROR": "Avec Belfius, un message d'erreur peut apparaître lorsque trop de comptes sont sélectionnés en même temps. Normalement, il est possible de sélectionner jusqu'à ±100 comptes.",
                "GKCCBEBB_RETRY": "Si vous obtenez toujours un message d'erreur, réessayez avec moins de comptes.",
                "REPEAT": "Répétez l'opération jusqu'à ce que tous vos comptes aient été ajoutés ou renouvelés.",
                "GEBABEBB_ERROR": "Un message d'erreur courant avec BNP Paribas Fortis, Fintro et Hello bank! est « Liste des comptes non disponible ». Dans la plupart des cas, ce problème peut être résolu en se rendant dans l'agence locale de BNP Paribas Fortis et en faisant lire l'eID pour mettre à jour les données personnelles.",
                "BBRUBEBB_LIMIT": "ING vous permet de sélectionner jusqu'à 50 comptes à la fois. La liste des comptes est divisée en pages de 50 comptes exactement.",
                "KREDBEBB": "Un problème courant avec KBC / CBC est que tous les comptes ne sont pas visibles. Cela indique que les autorisations sur ces comptes ne sont pas suffisantes (la procuration n'est pas suffisante, il faut un titulaire). Pour résoudre ce problème, il faut contacter le bureau local de KBC / CBC pour adapter les autorisations.",
                "DETAILED_1": "L'autorisation est demandée à la banque non seulement pour les nouveaux comptes. Une nouvelle autorisation est également demandée pour tous les comptes ajoutés précédemment. Cette autorisation est nécessaire car, dans le cas contraire, ces comptes ne seraient plus synchronisés et recevraient un statut d'erreur.",
                "DETAILED_2": "Si vous n'avez plus accès à un compte précédemment ajouté ou s'il a été fermé entre-temps, ce compte doit être archivé avant d'effectuer cette opération. Dans le cas contraire, l'ensemble de la procédure échouera.",
                "DETAILED_1_FOR_IMPORT": "Y a-t-il des comptes qui n'ont pas encore été synchronisés via Isabel Connect ? Dans ce cas, une nouvelle autorisation sera également demandée à la banque pour ces comptes. Cette autorisation est nécessaire car, dans le cas contraire, ces comptes ne seraient plus synchronisés et recevraient un statut d'erreur.",
                "DETAILED_2_FOR_IMPORT": "Si vous n'avez plus accès à l'un des comptes mentionnés au point précédent, ou si un tel compte a été fermé entre-temps, ce compte doit être archivé avant d'effectuer cette opération. Dans le cas contraire, l'ensemble de la procédure échouera.",
                "FINANCIAL_INSTITUTION_OFFERED_1_FOR_IMPORT": "Y a-t-il des comptes qui n'ont pas encore été synchronisés via Isabel Connect ? Sélectionnez alors ces comptes.",
                "FINANCIAL_INSTITUTION_OFFERED_2_FOR_IMPORT": "Si vous ne re-sélectionnez pas un compte mentionné au point précédent, il ne sera plus synchronisé et obtiendra un statut d'erreur.",
                "GLOBAL_FOR_IMPORT": "Avec cette banque, vous ne pouvez pas choisir les comptes à importer. Tous les comptes pour lesquels vous disposez des autorisations nécessaires seront autorisés automatiquement.",
                "SINGLE_2_FOR_IMPORT": "Répétez la procédure pour chaque compte dont vous souhaitez importer l'historique.",
                "REPEAT_FOR_IMPORT": "Répétez l'opération jusqu'à ce que l'historique ait été importé pour tous les comptes pour lesquels vous le souhaitez."
            },
            "ERROR": {
                "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                "IBAN": "IBAN non valide"
            },
            "CUSTOMER_REFERENCE": {
                "LABEL": "Numéro de client",
                "INFO": "Saisissez votre numéro de client de {{ bank }}."
            },
            "IBANS": {
                "LABEL": "Nouveaux comptes",
                "INFO": "Saisissez les IBAN des nouveaux comptes que vous souhaitez ajouter.",
                "PLACEHOLDER": "IBAN",
                "ADD": "Ajouter un compte"
            },
            "ACTIVE_ACCOUNTS": {
                "LABEL": "Comptes précédemment ajoutés",
                "INFO": "Liste des comptes précédemment ajoutés pour lesquels une nouvelle autorisation sera demandée.",
                "LABEL_FOR_IMPORT": "Autres comptes",
                "INFO_FOR_IMPORT": "Liste des comptes qui n'ont pas encore été synchronisés via Isabel Connect et pour lesquels une nouvelle autorisation sera demandée."
            },
            "IMPORT": {
                "TITLE": "Importer l'historique"
            },
            "ACCOUNTS_FOR_IMPORT": {
                "LABEL": "Comptes à importer",
                "INFO": "Sélectionnez les comptes pour lesquels vous souhaitez importer l'historique."
            }
        },
        "XS2A_REDIRECT": {
            "FI_ERROR": {
                "TITLE": "Échec de l'autorisation",
                "INFO": "La banque a donné les informations suivantes :",
                "ERROR": "Erreur",
                "ERROR_DESCRIPTION": "Description",
                "WHAT_NOW": {
                    "TITLE": "Et maintenant ?",
                    "INFO_1": "Avez-vous annulé le processus vous-même ? Dans ce cas, recommencez.",
                    "INFO_2": "Vous n'avez pas pu vous connecter à la banque ? Il est possible qu'il s'agisse d'un problème temporaire à la banque et que vous puissiez réessayer plus tard. Si le problème persiste, il y a probablement un problème avec vos paramètres client à la banque. Dans ce cas, contactez votre agence bancaire.",
                    "INFO_3": "Avez-vous reçu un message d'erreur à la banque après vous être connecté ? Dans la plupart des cas, cela indique que l'accès à un ou plusieurs comptes que vous essayez d'autoriser est impossible ou insuffisant.\u2028 Savez-vous quel(s) compte(s) est/sont concerné(s) ? Recommencez le processus sans ce(s) compte(s) ou contactez votre agence bancaire pour ajuster les autorisations sur le(s) compte(s).",
                    "INFO_4": "Vous avez tout essayé, mais cela ne fonctionne toujours pas ? Envoyez-nous toutes les informations utiles (numéro de client à la banque, IBAN que vous souhaitez autoriser, adresse et capture d'écran de la page d'erreur à la banque). Nous vérifierons avec la banque ce qui se passe."
                },
                "NO_AUTH": "Aucune autorisation n'a été accordée."
            },
            "AIAR_AUTH_ERROR": {
                "TITLE": "Échec de la récupération des infos sur le compte",
                "INFO": "Un problème s'est produit lors de la récupération des comptes pour lesquels l'autorisation a été accordée.\n\n\nLa banque nous a fourni un code pour l'autorisation réussie de vos comptes pour l'accès à partir de ROOV Business.\n\nToutefois, lors de la récupération de ces comptes auprès de la banque à l'aide du code fourni, les choses se sont mal passées.\n\nLe processus n'a donc pas été mené à son terme. Aucun compte n'a été ajouté et/ou l'autorisation des comptes n'a pas été renouvelée.",
                "WHAT_NOW": {
                    "TITLE": "Et maintenant ?",
                    "INFO_1": "Il est possible qu'il y ait un problème temporaire à la banque. Cela vaut la peine d'essayer à nouveau à une date ultérieure.",
                    "INFO_2": "Le problème persiste-t-il ? Envoyez-nous toutes les informations utiles (numéro de client à la banque, IBAN que vous souhaitez autoriser, adresse et capture d'écran de cette page). Nous vérifierons avec la banque ce qui se passe."
                }
            },
            "LOADING": "Traitement en cours...",
            "AIAR_AUTH": {
                "TITLE": "Autorisation réussie",
                "ACCOUNTS": "L'autorisation a été accordée avec succès pour le(s) compte(s) suivant(s) :",
                "SYNCING": "La synchronisation des soldes et des transactions a commencé.",
                "IMPORTANT": {
                    "TITLE": "Important",
                    "INFO_1": "La synchronisation complète des données du compte peut prendre un certain temps, en particulier pour les comptes nouvellement ajoutés ou lorsque l'autorisation a été accordée pour un grand nombre de comptes.",
                    "INFO_2": "L'historique disponible varie d'une banque à l'autre. La plupart mettent à disposition l'historique des 1, 2 ou 5 dernières années. Quelques-unes se limitent à 3 ou 6 mois."
                }
            },
            "TITLE": "Autorisation de comptes"
        },
        "ISABEL_REDIRECT": {
            "TITLE": "Mise en place d'Isabel Connect",
            "ISABEL_ERROR": {
                "TITLE": "Échec de l'autorisation",
                "NO_AUTH": "Aucune connexion n'a été établie.",
                "INFO": "Isabel 6 a donné les informations suivantes :",
                "ERROR": "Erreur",
                "ERROR_DESCRIPTION": "Description"
            },
            "LOADING": "Traitement en cours...",
            "AUTH_ERROR": {
                "TITLE": "La connexion avec Isabel 6 a échoué.",
                "INFO": "Un problème est survenu lors de la connexion avec Isabel 6.\n\n\nIsabel 6 nous a fourni un code pour la connexion réussie avec ROOV Business.\n\nCependant, lors de la validation du code fourni, les choses se sont mal passées.\n\nLe processus n'a donc pas été achevé."
            },
            "CONNECTED": {
                "TITLE": "Isabel Connect est actif"
            },
            "AUTHORIZED": {
                "SYNCING": "La synchronisation des soldes et des transactions a commencé.",
                "IMPORTANT": {
                    "INFO_1": "Il peut s'écouler un certain temps avant que les données du compte ne soient entièrement synchronisées.",
                    "INFO_2": "Par défaut, les nouveaux comptes dans Isabel 6 ne reçoivent pas d'historique de la banque et ne deviennent disponibles via Isabel Connect que dès qu'une nouvelle transaction est effectuée. Nous demandons actuellement aux banques de fournir un historique de 2 ans pour tous les comptes.",
                    "TITLE": "Important"
                }
            }
        },
        "DOCUMENT_PAYMENT_DIALOG": {
            "TITLE": "Paiement du document"
        },
        "DIALOG": {
            "QUEUED_ITEMS": {
                "SINGLE": "1 item à traiter",
                "MULTI": "{{count}} items à traiter"
            }
        },
        "PROCESS_DOCUMENT_DIALOG": {
            "TITLE": "Traitement du document",
            "BUTTON": {
                "PAY": {
                    "LABEL": "Payer"
                },
                "ASSIGN": {
                    "LABEL": "Attribuer"
                }
            },
            "ERROR": {
                "REQUIRED": "Tous les champs obligatoires n'ont pas été remplis",
                "REMITTANCE_INFORMATION": "Communication non valide",
                "MAT_DATEPICKER_MIN": "La date d'exécution ne doit pas se situer dans le passé",
                "MAT_DATEPICKER_PARSE": "Date non valide",
                "MIN": "Le montant doit être supérieur à 0",
                "EDITING": "Le bénéficiaire doit être gardé en premier",
                "IBAN": "IBAN non valide",
                "UNIQUE": "Il existe déjà un compte avec cet IBAN",
                "BENEFICIARY_NAME": "Nom non valide",
                "SAME_IBAN": "Le numéro de compte du bénéficiaire est égal au numéro de compte du paiement",
                "MAT_DATEPICKER_MAX": "La date d'exécution ne doit pas se situer plus d'un an dans le futur",
                "DOCUMENT_NAME_EDITING": "Le nom doit d'abord être enregistré"
            },
            "DELETE": {
                "TITLE": "Supprimer le document"
            }
        },
        "CC_ACCESS": {
            "MESSAGE": "Vous êtes connecté en tant que {{ user }} dans le bureau « {{ office }} »",
            "BUTTON": {
                "LABEL": "Fermer la session"
            }
        },
        "TRANSACTION_CATEGORIES": {
            "MAIN_CATEGORY_SUFFIX": {
                "TRANSFERS_IN": " (entrants)",
                "TRANSFERS_OUT": " (sortants)"
            }
        }
    },
    "NAVBAR": {
        "COLOR_MODE": {
            "dark": "Mode sombre",
            "light": "Mode clair",
            "system": "Suivre le système"
        }
    },
    "PAGINATOR": {
        "FIRST_PAGE_LABEL": "Première page",
        "ITEMS_PER_PAGE_LABEL": "Items par page",
        "LAST_PAGE_LABEL": "Dernière page",
        "NEXT_PAGE_LABEL": "Page suivante",
        "PREVIOUS_PAGE_LABEL": "Page précédente",
        "EMPTY_RANGE_LABEL": "aucun élément",
        "RANGE_LABEL_OF": "de"
    },
    "SEARCH_FIELD": {
        "PLACEHOLDER": "Recherche"
    },
    "FILTER_FIELD": {
        "PLACEHOLDER": "Filtre"
    },
    "STATUS": {
        "ACTIVE": "Actif",
        "ARCHIVED": "Archivé"
    },
    "SELECT_FIELD": {
        "SEARCH": "Recherche",
        "NOT_FOUND": "Aucun élément trouvé"
    },
    "MAINTENANCE": {
        "TITLE": "Maintenance en cours",
        "MESSAGE": "Nous sommes désolés pour le dérangement, mais nous effectuons une maintenance en ce moment. Nous serons de retour en ligne sous peu!"
    },
    "PDF_VIEWER": {
        "NEXT_PAGE": "Page suivante",
        "PREVIOUS_PAGE": "Page précédente"
    },
    "LOGOUT": {
        "TITLE": "Au revoir",
        "MESSAGE": "Votre session est terminée. Fermez cette fenêtre ou reconnectez-vous à ROOV Business.",
        "BUTTON": "Se reconnecter"
    },
    "AUTH": {
        "LOADING": "Chargement de l’autorisation"
    },
    "DOCUMENT_VIEWER": {
        "ZOOM_OUT": "Dézoomer",
        "ZOOM_IN": "Zoomer",
        "ZOOM_1": "Zoomer à 100 %",
        "ZOOM_FIT_WIDTH": "Zoomer à la largeur"
    }
}